import { jsx as r, jsxs as g, Fragment as Z } from "react/jsx-runtime";
import me, { useRef as mt, useState as N, useEffect as ft, forwardRef as st, Fragment as fe, Children as ue, useCallback as O, useMemo as ot, createContext as he, useContext as xe, memo as Y } from "react";
import { useTheme as lt, useMediaQuery as $t, Stack as T, LinearProgress as ve, Box as m, styled as B, List as Ht, Paper as nt, MenuItem as ye, ListItemText as Ot, ListItemIcon as Nt, IconButton as be, ClickAwayListener as ut, Popper as ht, ListItemButton as Ce, Fade as _t, TableCell as we, TableRow as Se, TableBody as Ie, createFilterOptions as ke, MenuList as Fe, Typography as Lt, Skeleton as Vt, Slider as Le } from "@mui/material";
import { styled as M } from "@mui/material/styles";
import "@mui/material/CssBaseline";
import { d as W, e as $, c as U, f as at, g as V, h as gt, b as R, i as St } from "./Tab-CO75KpXL.js";
import { s } from "./spacings-C27fg6SF.js";
import { b as rt, a as vt } from "./shadows-JVyVGdzD.js";
import { r as y } from "./roundings-rAN_HXvA.js";
import "@mui/material/useAutocomplete";
import { faCircleQuestion as De, faFileImport as Ae, faEyeDropper as Ee, faGripDotsVertical as Be, faXmark as Ut, faExclamationCircle as Me, faPlay as ze, faFlag as We } from "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import z from "@mui/material/Box";
import { T as A } from "./Typography-HkIo7ajX.js";
import { FontAwesomeIcon as Te } from "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import Re from "@mui/material/Dialog";
import Pe from "@mui/material/DialogTitle";
import $e from "@mui/material/DialogContent";
import He from "@mui/material/DialogActions";
import Oe from "@mui/material/Checkbox";
import { faSquareCheck as Ne, faSquareMinus as _e, faCrown as Ve, faCircleDot as Ue, faAngleRight as Ge } from "@fortawesome/pro-solid-svg-icons";
import { faSquare as je, faSquareCheck as Ze, faSquareMinus as Xe, faCircle as qe, faCircleDot as Ke } from "@fortawesome/pro-light-svg-icons";
import Ye from "@mui/material/Stack";
import Je from "@mui/material/Link";
import "@mui/material/Typography";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import { useDropzone as Qe } from "react-dropzone";
import tr from "@mui/material/Button";
import er from "@mui/material/IconButton";
import { faCircle as rr } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { T as J } from "./Tooltip-CKVc9519.js";
import { faXmark as Gt } from "@fortawesome/pro-regular-svg-icons/faXmark";
import yt from "@mui/material/Chip";
import or from "@mui/material/Breadcrumbs";
import { faSlashForward as ir } from "@fortawesome/pro-solid-svg-icons/faSlashForward";
import { faChevronRight as nr } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import ar from "@mui/material/Avatar";
import { faUser as sr } from "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "@mui/material/ButtonGroup";
import { S as lr } from "./ShadowBox-Bn6vo7Kx.js";
import "@mui/material/Switch";
import cr from "@mui/material/Radio";
import dr from "@mui/material/FormControl";
import jt from "@mui/material/FormLabel";
import Dt from "@mui/material/InputAdornment";
import pr from "@mui/material/OutlinedInput";
import gr from "@mui/material/FormHelperText";
import "@mui/material/TextField";
import "@mui/material/InputBase";
import "@mui/material/Autocomplete";
import "@mui/material/Input";
import { useVirtualizer as mr } from "@tanstack/react-virtual";
import { faMagnifyingGlass as fr } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import { faCheck as ur } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faCircleQuestion as It } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import { animated as hr } from "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import { Rnd as xr } from "react-rnd";
import { HexColorPicker as vr, HexColorInput as yr } from "react-colorful";
import { useDebounce as br } from "@uidotdev/usehooks";
import Cr from "use-eye-dropper";
import { useHotkeys as At, HotkeysProvider as wr } from "react-hotkeys-hook";
import { useUnmount as Zt } from "react-use";
import { g as Sr, u as Et, e as bt, v as Ir } from "./color-utils-Ck_i9mvj.js";
import "color";
import { a as kr, T as Fr } from "./TypeWriter-BgzZBTxS.js";
import { T as Lr } from "./TextFormatter-BVdWjwiB.js";
import "./AutoScrollContainer-CzyjIY1o.js";
import { flexRender as Dr } from "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { faPlus as Ar } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { C as Xt } from "./CircularProgress-TGiQxfpH.js";
import { useInView as Er, InView as Br } from "react-intersection-observer";
import "@mui/material/Slider";
import { faCircleExclamation as Mr } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";
const Bt = {
  common: {
    white: "#FFFFFF",
    black: "#000000"
  },
  tonalOffset: 0,
  text: {
    primary: "#000000",
    secondary: "rgba(0, 0, 0, 0.54)",
    // not defined yet
    disabled: "rgba(0, 0, 0, 0.38)"
    // not defined yet
  },
  [W.grey]: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#182230",
    900: "#101828",
    950: "#0C111D",
    main: "#667085",
    dark: "",
    light: "",
    contrastText: "#344054"
  },
  [W.primary]: {
    25: "#F5FAFF",
    50: "#EFF8FF",
    100: "#D1E9FF",
    200: "#B2DDFF",
    300: "#84CAFF",
    400: "#53B1FD",
    500: "#2E90FA",
    600: "#1570EF",
    700: "#175CD3",
    800: "#1849A9",
    900: "#194185",
    950: "#102A56",
    main: "#2E90FA",
    dark: "",
    light: "",
    contrastText: "#175CD3"
  },
  [W.error]: {
    25: "#FFFBFA",
    50: "#FEF3F2",
    100: "#FEE4E2",
    200: "#FECDCA",
    300: "#FDA29B",
    400: "#F97066",
    500: "#F04438",
    600: "#D92D20",
    700: "#B42318",
    800: "#912018",
    900: "#7A271A",
    950: "#55160C",
    main: "#F04438",
    dark: "",
    light: "",
    contrastText: "#B42318"
  },
  [W.warning]: {
    25: "#FFFCF5",
    50: "#FFFAEB",
    100: "#FEF0C7",
    200: "#FEDF89",
    300: "#FEC84B",
    400: "#FDB022",
    500: "#F79009",
    600: "#DC6803",
    700: "#B54708",
    800: "#93370D",
    900: "#7A2E0E",
    950: "#4E1D09",
    main: "#F79009",
    dark: "",
    light: "",
    contrastText: "#B54708"
  },
  [W.success]: {
    25: "#F6FEF9",
    50: "#ECFDF3",
    100: "#DCFAE6",
    200: "#ABEFC6",
    300: "#75E0A7",
    400: "#47CD89",
    500: "#17B26A",
    600: "#079455",
    700: "#067647",
    800: "#085D3A",
    900: "#074D31",
    950: "#053321",
    main: "#17B26A",
    dark: "",
    light: "",
    contrastText: "#067647"
  },
  // additional colors
  [W.indigo]: {
    25: "#F5F8FF",
    50: "#EEF4FF",
    100: "#E0EAFF",
    200: "#C7D7FE",
    300: "#A4BCFD",
    400: "#8098F9",
    500: "#6172F3",
    600: "#444CE7",
    700: "#3538CD",
    800: "#2D31A6",
    900: "#2D3282",
    950: "#1F235B",
    main: "#6172F3",
    dark: "",
    light: "",
    contrastText: "#3538CD"
  },
  [W.purple]: {
    25: "#FAFAFF",
    50: "#F4F3FF",
    100: "#EBE9FE",
    200: "#D9D6FE",
    300: "#BDB4FE",
    400: "#9B8AFB",
    500: "#7A5AF8",
    600: "#6938EF",
    700: "#5925DC",
    800: "#4A1FB8",
    900: "#3E1C96",
    950: "#27115F",
    main: "#7A5AF8",
    dark: "",
    light: "",
    contrastText: "#5925DC"
  },
  [W.pink]: {
    25: "#FEF6FB",
    50: "#FDF2FA",
    100: "#FCE7F6",
    200: "#FCCEEE",
    300: "#FAA7E0",
    400: "#F670C7",
    500: "#EE46BC",
    600: "#DD2590",
    700: "#C11574",
    800: "#9E165F",
    900: "#851651",
    950: "#4E0D30",
    main: "#EE46BC",
    dark: "",
    light: "",
    contrastText: "#C11574"
  },
  [W.rose]: {
    25: "#FFF5F6",
    50: "#FFF1F3",
    100: "#FFE4E8",
    200: "#FECDD6",
    300: "#FEA3B4",
    400: "#FD6F8E",
    500: "#F63D68",
    600: "#E31B54",
    700: "#C01048",
    800: "#A11043",
    900: "#89123E",
    950: "#510B24",
    main: "#F63D68",
    dark: "",
    light: "",
    contrastText: "#C01048"
  },
  action: {
    // Used to style components when they are in an active state, such as icons in active tabs or active buttons
    active: "#175CD3",
    // Applied when a user hovers over interactive elements like buttons, list items, and cards.
    hover: "#D1E9FF",
    // Used for components that are selected, such as selected items in a list or selected tabs.
    selected: "#1570EF",
    // Applied to components that are disabled, affecting their text and background color to indicate they are not interactive
    disabled: "#98A2B3",
    // Used when components receive focus, often for accessibility and indicating the element is ready for interaction
    focus: "#84CAFF"
  }
}, ya = {
  fontFamily: "Inter, sans-serif",
  fontSize: 16,
  // base font size
  fontWeightLight: $.regular,
  fontWeightRegular: $.regular,
  fontWeightMedium: $.medium,
  fontWeightSemibold: $.semibold,
  fontWeightBold: $.bold,
  h1: {
    // display xxl
    fontSize: "72px",
    fontWeight: $.bold,
    lineHeight: "90px"
  },
  h2: {
    // display xl
    fontSize: "60px",
    fontWeight: $.bold,
    lineHeight: "72px"
  },
  h3: {
    // display lg
    fontSize: "48px",
    fontWeight: $.bold,
    lineHeight: "60px"
  },
  h4: {
    // display md
    fontSize: "36px",
    fontWeight: $.bold,
    lineHeight: "44px"
  },
  h5: {
    // display sm
    fontSize: "30px",
    fontWeight: $.bold,
    lineHeight: "38px"
  },
  h6: {
    // display xs
    fontSize: "24px",
    fontWeight: $.semibold,
    lineHeight: "38px"
  },
  subtitle1: {
    // text xl
    fontSize: "20px",
    fontWeight: $.semibold,
    lineHeight: "30px"
  },
  subtitle2: {
    // text lg
    fontSize: "18px",
    fontWeight: $.medium,
    lineHeight: "28px"
  },
  body1: {
    // text md
    fontSize: "16px",
    fontWeight: $.regular,
    lineHeight: "24px"
  },
  body2: {
    // Text small
    fontSize: "14px",
    fontWeight: $.regular,
    lineHeight: "20px"
  },
  caption: {
    // Text xs
    fontSize: "12px",
    fontWeight: $.regular,
    lineHeight: "18px"
  },
  button: {
    // Text inside <Button>
    fontSize: "14px",
    fontWeight: $.regular,
    textTransform: "none"
  }
}, Ct = (t) => ({
  "& svg": {
    width: `${t}px`,
    height: `${t}px`
  }
}), pt = (t) => ({
  "& svg": {
    color: t
  }
}), et = (t) => ({
  "& svg": {
    color: t
  }
}), wt = {
  [U.xs]: 14,
  [U.small]: 16,
  [U.medium]: 20,
  [U.large]: 24,
  [U.xl]: 24,
  [U.xxl]: 24
}, ba = (t) => ({
  defaultProps: {
    size: U.medium,
    variant: "outlined",
    color: "primary",
    disableRipple: !0,
    disableFocusRipple: !0
  },
  variants: [
    {
      props: { size: U.xl },
      style: {
        // TODO: understand why this padding is not aligned to the DS spacings
        padding: "14px",
        ...Ct(wt.xl)
      }
    },
    {
      props: { size: U.xxl },
      style: {
        padding: t.spacing(s.xl),
        ...Ct(wt.xxl)
      }
    }
  ],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: e }) => {
      const o = wt[e.size ?? U.medium];
      return {
        transition: "background 0.2s linear, box-shadow 0.2s linear, border 0.2s linear, color 0.2s linear",
        borderRadius: e.isCircled ? t.rounding(y.full) : t.rounding(y.md),
        border: `1px solid ${t.palette.primary[300]}`,
        ...Ct(o),
        "&.Mui-disabled": {
          border: `1px solid ${t.palette.grey[200]}`,
          boxShadow: rt.xs,
          ...et(t.palette.grey[400])
        }
      };
    },
    /** Styles applied to the root element if `edge="start"`. */
    edgeStart: {},
    /** Styles applied to the root element if `edge="end"`. */
    edgeEnd: {},
    /** Styles applied to the root element if `color="inherit"`. */
    colorInherit: {},
    /** Styles applied to the root element if `color="primary"`. */
    colorPrimary: ({ ownerState: e }) => {
      switch (e.variant) {
        case at.contained:
          return {
            border: "1px solid transparent",
            ...et(t.palette.common.white),
            background: t.palette.primary[600],
            boxShadow: rt.xs,
            "&:hover": {
              background: t.palette.primary[700]
            },
            "&:active": {
              border: `1px solid ${t.palette.primary[600]}`,
              background: t.palette.primary[600],
              boxShadow: vt.primaryXs
            },
            "&.Mui-disabled": {
              background: t.palette.grey[100]
            }
          };
        case at.outlined:
          return {
            border: `1px solid ${t.palette.primary[300]}`,
            ...et(t.palette.primary[700]),
            background: t.palette.primary[50],
            boxShadow: rt.xs,
            "&:hover": {
              background: t.palette.primary[100]
            },
            "&:active": {
              border: `1px solid ${t.palette.primary[300]}`,
              background: t.palette.primary[50],
              boxShadow: vt.primaryXs
            },
            "&.Mui-disabled": {
              background: t.palette.common.white
            }
          };
        case at.text:
          return {
            border: "1px solid transparent",
            ...et(t.palette.primary[700]),
            background: "transparent",
            "&:hover": {
              background: t.palette.primary[50]
            },
            "&:active": {
              background: "transparent"
            }
          };
        default:
          return {};
      }
    },
    /** Styles applied to the root element if `color="secondary"`. */
    colorSecondary: ({ ownerState: e }) => {
      switch (e.variant) {
        case at.outlined:
          return {
            border: `1px solid ${t.palette.grey[300]}`,
            ...et(t.palette.grey[700]),
            background: t.palette.common.white,
            boxShadow: rt.xs,
            "&:hover": {
              background: t.palette.grey[100]
            },
            "&:active": {
              border: `1px solid ${t.palette.grey[300]}`,
              background: t.palette.common.white,
              boxShadow: vt.greyXs
            },
            "&.Mui-disabled": {
              background: t.palette.common.white
            }
          };
        case at.text:
          return {
            border: "1px solid transparent !important",
            ...et(t.palette.grey[600]),
            background: "transparent",
            "&:hover": {
              background: t.palette.grey[50],
              ...et(t.palette.primary[700])
            },
            "&:active": {
              background: "transparent"
            }
          };
        default:
          return {};
      }
    },
    /** Styles applied to the root element if `color="error"`. */
    colorError: {},
    /** Styles applied to the root element if `color="info"`. */
    colorInfo: {},
    /** Styles applied to the root element if `color="success"`. */
    colorSuccess: {},
    /** Styles applied to the root element if `color="warning"`. */
    colorWarning: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: t.spacing(s.md)
    },
    /** Styles applied to the root element if `size="medium"`. */
    sizeMedium: {
      // TODO: understand why this padding is not aligned to the DS spacings
      padding: "10px"
    },
    /** Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      padding: t.spacing(s.lg)
    }
  }
}), G = V.medium, zr = {
  [V.small]: "0 8px",
  [G]: "0 10px",
  [V.large]: "0 12px"
}, Wr = {
  [V.small]: "5px",
  [G]: "6px",
  [V.large]: "8px"
}, Mt = {
  [V.small]: "2px",
  [G]: "3px",
  [V.large]: "5px"
}, Tr = {
  [V.small]: "22px",
  [G]: "24px",
  [V.large]: "28px"
}, Rr = {
  [V.small]: "5px",
  [G]: "8px",
  [V.large]: "10px"
}, Pr = (t, e) => ({
  borderColor: t.palette.grey[300],
  background: t.palette.common.white,
  color: t.palette.grey[700],
  "& svg": {
    color: `${e[500]} !important`
  }
}), $r = (t) => ({
  border: `1px solid ${t[200]}`,
  background: t[50],
  color: t[700],
  "& svg": {
    color: `${t[500]} !important`
  },
  "&:hover": {
    background: t[100]
  }
}), Hr = (t) => Object.values(W).map((e) => ({
  props: { color: e, variant: "outlined" },
  style: Pr(t, t.palette[e])
})), Or = (t) => Object.values(W).map((e) => ({
  props: { color: e, variant: "filled" },
  style: $r(t.palette[e])
})), Ca = (t) => ({
  defaultProps: {
    variant: "filled",
    size: G,
    color: W.grey,
    // @ts-expect-error: it is possible to disable ripple but this prop is not presented in types
    disableRipple: !0
  },
  variants: [
    {
      props: { size: V.large },
      style: {
        height: "28px",
        fontSize: 14
      }
    },
    ...Or(t),
    ...Hr(t)
  ],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: e }) => {
      const o = e.isIconOnly ? Tr[e.size ?? G] : "auto";
      return {
        width: o,
        height: o,
        fontWeight: t.typography.fontWeightMedium
      };
    },
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      fontSize: 12,
      height: "22px"
    },
    /** Styles applied to the root element if `size="medium"`. */
    sizeMedium: {
      fontSize: 14,
      height: "24px"
    },
    /** Styles applied to the root element if `color="error"`. */
    colorError: {},
    /** Styles applied to the root element if `color="info"`. */
    colorInfo: {},
    /** Styles applied to the root element if `color="primary"`. */
    colorPrimary: {},
    /** Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {},
    /** Styles applied to the root element if `color="success"`. */
    colorSuccess: {},
    /** Styles applied to the root element if `color="warning"`. */
    colorWarning: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {},
    /** Styles applied to the avatar element. */
    avatar: ({ ownerState: e }) => ({
      borderRadius: t.rounding(y.full),
      overflow: "hidden",
      width: "16px",
      height: "16px",
      "& img": {
        width: "16px",
        height: "16px"
      },
      marginLeft: e.isIconOnly ? s.none : Mt[e.size ?? G]
    }),
    /** Styles applied to the icon element. */
    icon: ({ ownerState: e }) => {
      const o = e.isDotLeading ? Rr : Mt, i = e.isIconOnly ? s.none : o[e.size ?? G], n = e.isDotLeading ? "8px" : "12px";
      return {
        borderRadius: t.rounding(y.full),
        overflow: "hidden",
        width: n,
        height: n,
        marginLeft: i,
        ...e.isIconOnly && { marginRight: `${s.none} !important` }
      };
    },
    /** Styles applied to the label `span` element. */
    label: ({ ownerState: e }) => {
      const o = e.isIconOnly ? Wr : zr;
      return {
        padding: e.isIconOnly ? s.none : o[e.size ?? G],
        lineHeight: 1.5
      };
    },
    /** State class applied to the delete icon */
    deleteIcon: ({ ownerState: e }) => {
      const o = e.color ?? W.grey, i = t.palette[o], n = !!e["data-isCustomEndIcon"], a = i && "main" in i && n ? i.main : i[900];
      return {
        width: "14px",
        height: "14px",
        color: a,
        ...!n && { color: `${a} !important` },
        "&:hover": {
          color: `${a} !important`
        },
        ...n && { cursor: "default" }
      };
    },
    /** State class applied to the root element if keyboard focused. */
    focusVisible: {}
  }
}), Nr = {
  [gt.button]: s.md,
  [gt.text]: s.lg
}, _r = (t) => t === gt.text, qt = (t) => t ? Nr[t] : s.none, wa = (t) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      "& button": {
        backgroundColor: "transparent !important",
        "&:active": {
          backgroundColor: "transparent !important"
        },
        "&:focused": {
          backgroundColor: "transparent !important"
        },
        padding: s.none,
        margin: s.none,
        "& svg": {
          color: t.palette.grey[600],
          width: 20
        }
      }
    },
    /** Styles applied to the ol element. */
    ol: {},
    /** Styles applied to the li element. */
    li: ({ ownerState: e }) => {
      const o = _r(e.variant) ? t.palette.primary[700] : t.palette.grey[700], i = e.children ?? [], n = Array.isArray(i) ? i.length === 1 : !1, a = t.palette.grey[600];
      return {
        fontSize: 14,
        lineHeight: "20px",
        // if selector by tag is not enough, add data-attr to the element
        "& a": {
          display: "flex",
          alignItems: "center",
          "& svg": {
            width: 16,
            height: 16,
            color: t.palette.grey[500]
          },
          fontWeight: t.typography.fontWeightMedium,
          color: `${a} !important`,
          textDecoration: "none",
          "&:hover": {
            color: a
          }
        },
        "& p": {
          display: "flex",
          alignItems: "center",
          padding: t.spacing(s.xs, s.md),
          background: n ? "none" : t.palette.grey[50],
          borderRadius: t.rounding(y.sm),
          color: n ? a : o,
          "& svg": {
            width: 16,
            height: 16,
            color: n ? a : t.palette.primary[500]
          },
          fontWeight: t.typography.fontWeightSemibold
        }
      };
    },
    /** Styles applied to the separator element. */
    separator: ({ ownerState: e }) => ({
      color: t.palette.grey[300],
      margin: t.spacing(s.none, qt(e.variant)),
      "& svg": {
        width: 8,
        height: 16,
        padding: t.spacing(s.none, s.sm)
      }
    })
  }
}), Vr = {
  [R.xs]: s["3xl"],
  [R.small]: s["4xl"],
  [R.medium]: s["5xl"],
  [R.large]: s["6xl"],
  [R.xl]: 7,
  [R.xxl]: s["7xl"]
}, Ur = {
  [R.xs]: s.lg,
  [R.small]: "14px",
  [R.medium]: s.xl,
  [R.large]: "18px",
  [R.xl]: s["2xl"],
  [R.xxl]: s["3xl"]
}, Gr = {
  [R.xs]: "12px",
  [R.small]: "14px",
  [R.medium]: "16px",
  [R.large]: "20px",
  [R.xl]: "22px",
  [R.xxl]: "22px"
}, Kt = R.medium, Sa = (t) => ({
  defaultProps: {
    sizes: Kt
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: e }) => {
      const o = e.sizes, i = t.spacing(Vr[o]);
      return {
        overflow: "visible",
        position: "relative",
        background: t.palette.grey[100],
        width: i,
        height: i,
        zIndex: 1,
        "&:before": {
          content: "''",
          width: "100%",
          borderRadius: t.rounding(y.full),
          position: "absolute",
          inset: 0,
          border: "1px solid",
          borderColor: "rgba(0, 0, 0, 0.08)",
          height: "100%",
          zIndex: 2
        },
        "& img": {
          position: "relative",
          width: i,
          height: i,
          borderRadius: t.rounding(y.full),
          overflow: "hidden"
        }
      };
    },
    /** Styles applied to the root element if not `src` or `srcSet`. */
    colorDefault: {},
    /** Styles applied to the root element if `variant="circular"`. */
    circular: ({ ownerState: e }) => {
      const o = e.sizes, i = t.spacing(Ur[o]), n = Gr[o];
      return {
        "&:after": {
          content: "''",
          position: "absolute",
          top: 0,
          left: 0,
          width: "calc(100% + 4px)",
          height: "calc(100% + 4px)",
          transform: "translate(-2px, -2px)",
          borderRadius: t.rounding(y.full),
          border: "2px solid",
          borderColor: t.palette.common.white,
          transition: "all 0.2s linear"
        },
        "&:focus-visible": {
          outline: "none !important",
          "&:after": {
            width: "calc(100% + 8px)",
            height: "calc(100% + 8px)",
            transform: "translate(-4px, -4px)",
            border: "4px solid",
            borderColor: t.palette.grey[100]
          }
        },
        "& p, text": {
          fontWeight: t.typography.fontWeightMedium,
          fontSize: i,
          textTransform: "uppercase",
          color: t.palette.grey[600]
        },
        "& > svg": {
          color: t.palette.grey[950],
          width: n,
          height: n
        }
      };
    },
    /** Styles applied to the root element if `variant="rounded"`. */
    rounded: {},
    /** Styles applied to the root element if `variant="square"`. */
    square: {},
    /** Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {},
    /** Styles applied to the fallback icon */
    fallback: {}
  }
}), b = ({ icon: t, ...e }) => /* @__PURE__ */ r(
  Te,
  {
    icon: t,
    ...e
  }
), jr = M(er, {
  shouldForwardProp: (t) => t !== "isCircled" && t !== "disableBackground" && t !== "hasPadding"
})(
  ({ theme: t, isCircled: e, disableBackground: o, hasPadding: i = !0 }) => ({
    ...e && {
      borderRadius: t.rounding(y.full)
    },
    ...o && {
      background: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "none !important"
      },
      "&:focus": {
        outline: "none !important",
        boxShadow: "none !important"
      },
      "&:active": {
        background: "none !important"
      }
    },
    ...!i && {
      padding: 0
    }
  })
), ct = ({
  children: t,
  label: e,
  isCircled: o = !1,
  disableBackground: i = !1,
  ...n
}) => /* @__PURE__ */ r(
  jr,
  {
    ...n,
    "aria-label": e,
    isCircled: o,
    disableBackground: i,
    children: t
  }
), kt = ({
  disableBackground: t = !1,
  iconColor: e = void 0,
  onClose: o
}) => /* @__PURE__ */ r(
  ct,
  {
    label: "Close",
    onClick: o,
    variant: "text",
    color: "secondary",
    disableBackground: t,
    size: "small",
    children: /* @__PURE__ */ r(
      b,
      {
        style: { color: e },
        icon: Gt,
        size: "xs"
      }
    )
  }
), Zr = ({
  title: t,
  description: e = void 0,
  direction: o,
  hasBottomPadding: i = !1,
  hasDivider: n = !1,
  iconProps: a = void 0,
  onClose: l = void 0,
  isLoading: c = !1
}) => {
  const d = lt(), p = $t(d.breakpoints.down("sm")), f = o === "horizontal", x = o === "centered", h = o === "vertical", v = f ? "row" : "column", w = !!e, S = !!l, k = p ? s.md : s.xl, L = (a == null ? void 0 : a.variant) !== void 0, I = p ? s.xl : s["3xl"], C = I + (S && f ? k : 0), u = 56;
  return /* @__PURE__ */ g(Z, { children: [
    !!c && /* @__PURE__ */ r(T, { sx: { position: "absolute", right: 0, left: 0, top: 0 }, children: /* @__PURE__ */ r(ve, {}) }),
    !!L && /* @__PURE__ */ r(
      T,
      {
        sx: {
          position: "absolute",
          inset: 0,
          p: I,
          ...x && {
            left: "50%",
            transform: `translateX(-${u / 2}px)`,
            px: 0
          }
        },
        children: /* @__PURE__ */ r(
          Kr,
          {
            ...a,
            variant: a.variant ?? "primary",
            hasOuterCircles: a.hasOuterCircles ?? !1
          }
        )
      }
    ),
    /* @__PURE__ */ g(
      T,
      {
        sx: {
          position: "relative",
          ...n && { borderBottom: "1px solid", borderColor: "grey.200" }
        },
        children: [
          !!S && /* @__PURE__ */ r(
            m,
            {
              position: "absolute",
              zIndex: 10,
              sx: { top: d.spacing(k), right: d.spacing(k) },
              children: /* @__PURE__ */ r(kt, { onClose: l })
            }
          ),
          /* @__PURE__ */ g(
            T,
            {
              direction: v,
              spacing: s.xl,
              sx: {
                p: I,
                pr: C,
                pb: i ? s["2xl"] : 0,
                alignItems: h || w && f ? "start" : "center"
              },
              children: [
                !!a && /* @__PURE__ */ g(T, { children: [
                  !!L && /* @__PURE__ */ r(
                    m,
                    {
                      height: u,
                      width: u
                    }
                  ),
                  !L && (!!a.icon || !!a.customIcon) && /* @__PURE__ */ r(T, { sx: { height: 47, justifyContent: "center" }, children: a.icon ? /* @__PURE__ */ r(
                    b,
                    {
                      icon: a.icon,
                      size: "xl"
                    }
                  ) : a.customIcon })
                ] }),
                /* @__PURE__ */ g(
                  T,
                  {
                    direction: "column",
                    spacing: s.xs,
                    sx: {
                      ...x && {
                        alignItems: "center"
                      },
                      position: "relative",
                      zIndex: 1
                    },
                    children: [
                      /* @__PURE__ */ r(
                        Q.Header,
                        {
                          component: "div",
                          sx: { p: 0 },
                          children: /* @__PURE__ */ r(
                            A,
                            {
                              variant: "text",
                              size: "lg",
                              fontWeight: "semibold",
                              color: "grey.950",
                              children: t
                            }
                          )
                        }
                      ),
                      !!e && /* @__PURE__ */ r(
                        A,
                        {
                          variant: "text",
                          size: "sm",
                          color: "grey.600",
                          children: e
                        }
                      )
                    ]
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}, Xr = ({
  children: t,
  isRightAligned: e = !1,
  hasDivider: o = !1,
  checkboxProps: i = void 0,
  isFullWidth: n = !1
}) => {
  const a = lt(), l = $t(a.breakpoints.down("sm")), c = !!i, d = e || c, p = l ? s.xl : s["3xl"];
  return /* @__PURE__ */ g(
    T,
    {
      direction: l ? "column-reverse" : "row",
      sx: {
        width: n ? "100%" : "auto",
        justifyContent: d ? "end" : "space-between",
        alignItems: l ? "start" : "center",
        "& > *": {
          width: l || !d ? "100%" : "auto"
        },
        ...o && {
          borderTop: "1px solid",
          borderColor: "grey.200"
        },
        px: p,
        pb: p,
        pt: o ? s["3xl"] : s["4xl"]
      },
      spacing: s.lg,
      children: [
        !!c && /* @__PURE__ */ r(
          m,
          {
            sx: {
              flex: "1 0 35%",
              width: "auto",
              "&&": {
                ml: l ? 0 : 8.75
              }
            },
            children: /* @__PURE__ */ r(
              Jt,
              {
                size: "small",
                checked: i.checked,
                onChange: i.onChange,
                label: i.label
              }
            )
          }
        ),
        t
      ]
    }
  );
}, Q = ({
  children: t,
  isOpen: e,
  isClosableOnClickOutside: o = !0,
  closeIconColor: i = void 0,
  disableCloseIconBackground: n = !1,
  size: a = "sm",
  sx: l = {},
  minHeight: c = void 0,
  customSize: d = void 0,
  onClose: p,
  onKeyDown: f = () => {
  },
  onKeyUp: x = () => {
  },
  useDefaultCloseButton: h = !0,
  closeButtonCustomPosition: v = { top: 16, right: 16 },
  overlayOpacity: w = 0.5,
  backdropBlur: S = void 0
}) => /* @__PURE__ */ g(
  Re,
  {
    open: e,
    onKeyDown: f,
    onKeyUp: x,
    onClose: (k, L) => {
      L === "backdropClick" && !o || p();
    },
    scroll: "paper",
    sx: {
      "& .MuiDialog-container": {
        ...!!c && {
          flexDirection: "column"
        }
      },
      "& .MuiDialog-paper": {
        ...d && {
          maxWidth: d
        },
        ...!!c && {
          minHeight: `min(${c}px, calc(100% - 64px))`
        }
      },
      "& .MuiModal-backdrop": {
        backgroundColor: `rgba(0, 0, 0, ${w})`,
        ...S && {
          backdropFilter: `blur(${S}px)`
        }
      },
      ...l
    },
    maxWidth: a,
    fullWidth: !0,
    children: [
      !!h && /* @__PURE__ */ r(
        z,
        {
          position: "absolute",
          zIndex: 10,
          ...v,
          children: /* @__PURE__ */ r(
            kt,
            {
              iconColor: i,
              disableBackground: n,
              onClose: p
            }
          )
        }
      ),
      t
    ]
  }
);
Q.CloseButton = kt;
Q.Header = Pe;
Q.HeaderWithIcon = Zr;
Q.Body = $e;
Q.Footer = He;
Q.Actions = Xr;
const Yt = ({
  label: t = "",
  description: e = "",
  size: o = "medium",
  disabled: i = !1,
  disabledReason: n = "",
  disabledReasonDescription: a = "",
  tooltipPlacement: l = "bottom",
  maxTooltipWidth: c = void 0,
  isReversed: d = !1,
  children: p,
  docLink: f = ""
}) => /* @__PURE__ */ g(
  Ye,
  {
    direction: d ? "row-reverse" : "row",
    alignItems: e ? "flex-start" : "center",
    ...!!t && { spacing: o === "small" ? s.md : s.lg },
    children: [
      /* @__PURE__ */ r(
        J,
        {
          title: i && n ? n : "",
          text: i && a ? a : "",
          placement: l,
          maxBodyWidth: c,
          minBodyWidth: c,
          shouldHighlightChildIcon: !1,
          children: p
        }
      ),
      !!t && /* @__PURE__ */ g(z, { ...!!d && { textAlign: "right" }, children: [
        /* @__PURE__ */ r(
          A,
          {
            variant: "text",
            size: "sm",
            fontWeight: "medium",
            color: "grey.700",
            children: t
          }
        ),
        !!e && /* @__PURE__ */ g(
          A,
          {
            variant: "text",
            size: "sm",
            fontWeight: "regular",
            color: "grey.600",
            children: [
              e,
              !!f && /* @__PURE__ */ g(Z, { children: [
                " ",
                /* @__PURE__ */ r(
                  Je,
                  {
                    rel: "noopener noreferrer",
                    target: "_blank",
                    color: "grey.700",
                    href: f,
                    "aria-label": "Documentation link",
                    children: /* @__PURE__ */ r(b, { icon: De })
                  }
                )
              ] })
            ]
          }
        )
      ] })
    ]
  }
), Jt = ({
  size: t = "medium",
  disabled: e = !1,
  tooltipPlacement: o = void 0,
  maxTooltipWidth: i = void 0,
  disabledReason: n = "",
  disabledReasonDescription: a = "",
  label: l = "",
  description: c = "",
  isReversed: d = !1,
  docLink: p,
  ariaLabel: f = void 0,
  ...x
}) => /* @__PURE__ */ r(
  Yt,
  {
    label: l,
    description: c,
    maxTooltipWidth: i,
    size: t,
    isReversed: d,
    tooltipPlacement: o,
    disabled: e,
    disabledReason: n,
    disabledReasonDescription: a,
    docLink: p,
    children: /* @__PURE__ */ r(
      Oe,
      {
        size: t,
        disabled: e,
        icon: /* @__PURE__ */ r(b, { icon: je }),
        checkedIcon: /* @__PURE__ */ r(b, { icon: e ? Ze : Ne }),
        indeterminateIcon: /* @__PURE__ */ r(b, { icon: e ? Xe : _e }),
        inputProps: {
          ...!!l && { "aria-label": l },
          ...!!f && { "aria-label": f }
        },
        ...x
      }
    )
  }
), Qt = ({
  children: t,
  startIcon: e,
  hasPadding: o = !0,
  isLoading: i = !1,
  ...n
}) => {
  const a = { ...n };
  return n.color === "red" && (a.color = "error"), // @ts-expect-error: renaming for mui error color
  /* @__PURE__ */ r(
    tr,
    {
      ...a,
      startIcon: (
        // eslint-disable-next-line react/jsx-no-leaked-render
        i ? /* @__PURE__ */ r(
          Xt,
          {
            size: 20,
            label: "Action in progress"
          }
        ) : e
      ),
      sx: {
        ...o ? {} : { padding: 0 }
      },
      children: t
    }
  );
}, qr = ({ children: t, label: e = "", ...o }) => /* @__PURE__ */ r(
  Qt,
  {
    ...o,
    ...!!e && { "aria-label": e },
    children: t
  }
), Kr = ({
  variant: t,
  icon: e = void 0,
  hasOuterCircles: o = !0,
  hasAdditionalBackgroundLayer: i = !0,
  customIcon: n = void 0
}) => {
  const a = lt(), l = a.palette.grey[200];
  return /* @__PURE__ */ g(Z, { children: [
    !!o && /* @__PURE__ */ r(
      z,
      {
        sx: {
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          overflow: "hidden"
        },
        children: /* @__PURE__ */ g(
          "svg",
          {
            height: "100%",
            style: {
              maxWidth: "100%",
              maxHeight: "100%"
            },
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ r(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "48",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.9"
                }
              ),
              /* @__PURE__ */ r(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "72",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.7"
                }
              ),
              /* @__PURE__ */ r(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "96",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.5"
                }
              ),
              /* @__PURE__ */ r(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "120",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.3"
                }
              ),
              /* @__PURE__ */ r(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "144",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.2"
                }
              ),
              /* @__PURE__ */ r(
                "circle",
                {
                  cx: "51",
                  cy: "52",
                  r: "168",
                  stroke: l,
                  strokeWidth: "1",
                  opacity: "0.1"
                }
              )
            ]
          }
        )
      }
    ),
    !!e && /* @__PURE__ */ r(
      z,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "56px",
          height: "56px",
          padding: s.lg,
          borderRadius: y.full,
          border: i ? `8px solid ${a.palette[t][50]}` : void 0,
          background: a.palette[t][100]
        },
        children: /* @__PURE__ */ r(z, { color: `${t}.600`, children: n ?? /* @__PURE__ */ r(b, { icon: e }) })
      }
    )
  ] });
}, Yr = B(m)(({ theme: t }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: t.palette.error.main,
  borderRadius: t.rounding(y.xxs),
  padding: t.spacing(s.xxs, s.xs)
})), Jr = B("span")(({ theme: t }) => ({
  color: t.palette.common.white,
  fontSize: 10,
  fontWeight: "bold",
  lineHeight: 1.2,
  fontFamily: t.typography.fontFamily
})), Ia = ({ fileType: t = "PPTX", width: e = 32, height: o = 40, sx: i = void 0 }) => {
  const n = mt(null), [a, l] = N(0);
  return ft(() => {
    if (n.current) {
      const c = n.current.offsetWidth;
      l(`${c * 0.25}px`);
    }
  }, [t]), /* @__PURE__ */ g(m, { sx: { position: "relative", marginLeft: a, ...i }, children: [
    /* @__PURE__ */ r(
      "svg",
      {
        width: e,
        height: o,
        viewBox: "0 0 32 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ r(
          "path",
          {
            d: "M0.75 4C0.75 2.20508 2.20508 0.75 4 0.75H20C20.1212 0.75 20.2375 0.798159 20.3232 0.883885L31.1161 11.6768C31.2018 11.7625 31.25 11.8788 31.25 12V36C31.25 37.7949 29.7949 39.25 28 39.25H4C2.20507 39.25 0.75 37.7949 0.75 36V4Z",
            fill: "white",
            stroke: "#D0D5DD",
            strokeWidth: "1.5"
          }
        )
      }
    ),
    /* @__PURE__ */ r(
      m,
      {
        sx: {
          position: "absolute",
          top: 0,
          right: 0
        },
        children: /* @__PURE__ */ r(
          "svg",
          {
            width: e * 0.4,
            height: o * 0.33,
            viewBox: "0 0 13 13",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ r(
              "path",
              {
                d: "M1 0.5V8C1 10.2091 2.79086 12 5 12H12.5",
                stroke: "#D0D5DD",
                strokeWidth: "1.5"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ r(
      m,
      {
        ref: n,
        sx: {
          position: "absolute",
          left: 0,
          bottom: 0,
          transform: "translate(-25%, -50%)"
        },
        children: /* @__PURE__ */ r(Yr, { children: /* @__PURE__ */ r(Jr, { children: t }) })
      }
    )
  ] });
}, Qr = ({
  children: t,
  color: e = "primary",
  href: o = "",
  target: i = "_self",
  hasPadding: n = !0,
  ...a
}) => /* @__PURE__ */ r(
  Qt,
  {
    ...a,
    color: e,
    isLink: !0,
    variant: "text",
    href: o,
    target: i,
    hasPadding: n,
    children: t
  }
), to = B(ct, {
  shouldForwardProp: (t) => t !== "theme" && t !== "isActive"
})(({ theme: t, isActive: e }) => ({
  display: "flex",
  gap: t.spacing(s.xs),
  alignItems: "center",
  ...e ? {
    backgroundColor: t.palette.primary[50],
    transition: "background-color 0.2s ease",
    color: t.palette.primary[600],
    "&:hover": {
      backgroundColor: t.palette.primary[50],
      color: t.palette.primary[600],
      "& svg": {
        color: t.palette.primary[600]
      }
    },
    "& svg": {
      color: t.palette.primary[600]
    }
  } : {
    "&:hover:not(.Mui-disabled)": {
      backgroundColor: t.palette.grey[200],
      color: t.palette.grey[800],
      "& svg": {
        color: t.palette.grey[800]
      }
    },
    "&.Mui-disabled": {
      boxShadow: "none"
    }
  }
})), eo = (t, e) => t ? "grey.400" : e ? "primary.600" : "grey.700", ro = ({ action: t, isActive: e, size: o = "small" }) => /* @__PURE__ */ r(
  J,
  {
    title: t.tooltip ?? "",
    shouldHighlightChildIcon: !1,
    ...t.isDisabled ? t.disabledTooltip ?? {} : {},
    children: /* @__PURE__ */ r(m, { children: /* @__PURE__ */ g(
      to,
      {
        label: t.label,
        isActive: e,
        onClick: t.onClick,
        color: "secondary",
        variant: "text",
        size: o,
        disabled: t.isDisabled,
        children: [
          !!t.icon && /* @__PURE__ */ r(b, { icon: t.icon }),
          !!(!t.icon || t.shouldShowLabel) && /* @__PURE__ */ r(
            A,
            {
              variant: "text",
              size: "sm",
              fontWeight: "semibold",
              color: eo(t.isDisabled, e),
              children: t.label
            }
          ),
          !!t.endIcon && /* @__PURE__ */ r(b, { icon: t.endIcon })
        ]
      }
    ) })
  }
), te = (t) => ({
  backgroundColor: t.palette.warning[50],
  border: `1px solid ${t.palette.warning[400]}`,
  color: t.palette.warning[600],
  "& svg": {
    color: t.palette.warning[400]
  },
  "&:hover": {
    backgroundColor: t.palette.warning[100],
    color: t.palette.warning[700],
    border: `1px solid ${t.palette.warning[400]}`,
    outline: "none"
  },
  "&.Mui-disabled": {
    backgroundColor: t.palette.warning[50],
    border: `1px solid ${t.palette.warning[400]}`,
    color: t.palette.warning[600],
    "& svg": {
      color: t.palette.warning[400]
    }
  }
}), ka = B(qr)(({ theme: t }) => te(t)), oo = B(ct)(({ theme: t }) => te(t)), io = ({
  disabledTooltipProps: t = {},
  tooltipProps: e = {},
  buttonProps: o
}) => /* @__PURE__ */ r(
  J,
  {
    ...o.disabled ? t : e,
    shouldHighlightChildIcon: !1,
    children: /* @__PURE__ */ r(m, { children: /* @__PURE__ */ r(
      oo,
      {
        ...o,
        label: o.label ?? "Upgrade",
        children: /* @__PURE__ */ r(b, { icon: Ve })
      }
    ) })
  }
), no = ({ ...t }) => {
  const e = { ...t };
  if (t.endIcon && (delete e.endIcon, e.deleteIcon = t.endIcon), e.isIconOnly)
    return /* @__PURE__ */ r(
      yt,
      {
        variant: e.variant,
        color: e.color,
        size: e.size,
        icon: e.icon,
        isIconOnly: !0,
        onClick: e.onClick
      }
    );
  if (e.isDotLeading)
    return /* @__PURE__ */ r(
      yt,
      {
        ...e,
        isDotLeading: !0,
        avatar: void 0,
        icon: /* @__PURE__ */ r(b, { icon: rr })
      }
    );
  const o = e.avatar ? /* @__PURE__ */ r(
    lo,
    {
      picture: e.avatar.imageSrc,
      name: e.avatar.name,
      size: "xs"
    }
  ) : void 0;
  return /* @__PURE__ */ r(
    yt,
    {
      ...e,
      deleteIcon: e.deleteIcon ?? /* @__PURE__ */ r(
        b,
        {
          icon: Gt,
          "data-testid": "DeleteIcon"
        }
      ),
      avatar: o,
      ...!e.onDelete && t.endIcon && {
        onDelete: () => {
        },
        deleteIcon: e.deleteIcon,
        "data-isCustomEndIcon": !0
      },
      ...!!e.href && { component: "a", clickable: !0 }
    }
  );
}, ao = {
  [St.arrow]: /* @__PURE__ */ r(b, { icon: nr }),
  [St.slash]: /* @__PURE__ */ r(b, { icon: ir })
}, Fa = ({
  breadcrumbs: t,
  LinkComponent: e,
  maxItems: o = void 0,
  itemsBeforeCollapse: i = 2,
  itemsAfterCollapse: n = 1,
  variant: a = gt.text,
  separator: l = St.arrow
}) => /* @__PURE__ */ r(
  or,
  {
    "aria-label": "breadcrumbs",
    variant: a,
    separator: ao[l],
    maxItems: o,
    itemsBeforeCollapse: i,
    itemsAfterCollapse: n,
    children: t.map(({ label: c, icon: d, ...p }, f) => {
      const x = f === t.length - 1, h = /* @__PURE__ */ g(Z, { children: [
        !!d && /* @__PURE__ */ r(
          z,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              ...!!c && { mr: qt(a) }
            },
            children: /* @__PURE__ */ r(b, { icon: d })
          }
        ),
        c
      ] });
      return x ? /* @__PURE__ */ r(
        A,
        {
          variant: "text",
          size: "sm",
          children: h
        },
        f
      ) : /* @__PURE__ */ r(
        e,
        {
          ...p,
          children: h
        },
        f
      );
    })
  }
), so = (t) => {
  var o, i;
  const e = t.trim().split(/\s+/);
  return e.length === 1 ? e[0].charAt(0) : `${(o = e[0]) == null ? void 0 : o.charAt(0)}${(i = e[1]) == null ? void 0 : i.charAt(0)}`;
}, lo = ({
  picture: t = "",
  name: e = "",
  icon: o = void 0,
  forcedIcon: i = void 0,
  size: n = Kt,
  shouldShowTitle: a = !0,
  shouldForceInitials: l = !1,
  shouldForceIcon: c = !1,
  onClick: d = () => {
  },
  className: p = void 0
  /* will be used in future */
  /* Badge = null, */
  /* badgePosition = 'bottom-right', */
}) => {
  const [f, x] = N(!0), h = !t || t && !f, v = !!e && !!(l || h), w = c || h && !e;
  return /* @__PURE__ */ g(
    ar,
    {
      variant: "circular",
      sizes: n,
      ...e && a && { title: e },
      ...!l && !c && t && { src: t, alt: e || "avatar" },
      imgProps: {
        onError: () => {
          x(!1);
        }
      },
      onClick: d,
      className: p,
      children: [
        !!v && /* @__PURE__ */ r(A, { variant: "text", children: so(e) }),
        !!w && !i && /* @__PURE__ */ r(b, { icon: o ?? sr }),
        !!i && i
      ]
    }
  );
}, co = B(lr, {
  shouldForwardProp: (t) => t !== "theme"
})(({ theme: t }) => ({
  display: "flex",
  flexDirection: "row",
  gap: t.spacing(s.xs),
  padding: t.spacing(s.xs),
  borderRadius: t.rounding(y.md),
  border: `1px solid ${t.palette.grey[100]}`,
  backgroundColor: t.palette.common.white
})), La = ({ actions: t, activeAction: e, size: o = "small" }) => /* @__PURE__ */ r(co, { shadowSize: "md", children: t.map((i) => /* @__PURE__ */ r(
  ro,
  {
    action: i,
    isActive: !!e && i.id === e,
    size: o
  },
  i.id
)) }), po = ({
  size: t = "medium",
  disabled: e = !1,
  disabledReason: o = "",
  label: i = "",
  description: n = "",
  disabledReasonDescription: a = "",
  tooltipPlacement: l = void 0,
  maxTooltipWidth: c = void 0,
  isReversed: d = !1,
  docLink: p,
  ...f
}) => {
  const x = e ? Ke : Ue;
  return /* @__PURE__ */ r(
    Yt,
    {
      label: i,
      description: n,
      size: t,
      maxTooltipWidth: c,
      isReversed: d,
      disabled: e,
      disabledReason: o,
      tooltipPlacement: l,
      disabledReasonDescription: a,
      docLink: p,
      children: /* @__PURE__ */ r(
        cr,
        {
          size: t,
          disabled: e,
          inputProps: { ...!!i && { "aria-label": i } },
          icon: /* @__PURE__ */ r(b, { icon: qe }),
          checkedIcon: /* @__PURE__ */ r(b, { icon: x }),
          ...f
        }
      )
    }
  );
}, go = (t, e) => t ? /* @__PURE__ */ r(b, { icon: It }) : e ? /* @__PURE__ */ r(b, { icon: Mr }) : null, mo = ({
  errorText: t,
  warningText: e,
  isDisabled: o
}) => o ? "primary" : t ? "error" : e ? "warning" : "primary", Ft = st(
  ({
    value: t = "",
    onChange: e,
    label: o = "",
    description: i = "",
    helperText: n = "",
    errorText: a = "",
    warningText: l = "",
    startIcon: c = null,
    charsLimit: d = void 0,
    isDisabled: p = !1,
    isMultiline: f = !1,
    inputProps: x = {},
    endAdornment: h = null,
    shouldShowCharsLimit: v = !0,
    dataTest: w = void 0,
    ...S
  }, k) => {
    const L = a || l || n, I = mo({ errorText: a, warningText: l, isDisabled: p }), C = i ? J : fe, u = !!a.trim() || void 0, F = !!l.trim() && !u || void 0, P = go(i, !!u || !!F), X = !S.rows && P;
    return /* @__PURE__ */ g(
      dr,
      {
        color: I,
        fullWidth: !0,
        "data-test": w,
        children: [
          !!o && /* @__PURE__ */ r(jt, { children: o }),
          /* @__PURE__ */ r(
            pr,
            {
              ...S,
              value: t,
              onChange: (q) => {
                if (typeof e != "function")
                  return;
                const K = q.target.value.length;
                if (d) {
                  const E = K > d, H = K >= t.length;
                  if (E && H)
                    return;
                }
                e(q);
              },
              disabled: p,
              multiline: f,
              inputRef: k,
              inputProps: x,
              startAdornment: !!c && /* @__PURE__ */ r(Dt, { position: "start", children: c }),
              endAdornment: /* @__PURE__ */ g(Z, { children: [
                !!h && h,
                !!X && /* @__PURE__ */ r(C, { title: !p && i || "", children: /* @__PURE__ */ r(Dt, { position: "end", children: P }) })
              ] })
            }
          ),
          /* @__PURE__ */ g(z, { sx: { display: "flex", alignItems: "flex-start", justifyContent: "space-between" }, children: [
            !!L && /* @__PURE__ */ r(
              gr,
              {
                error: !p && u,
                warning: !p && F,
                children: L
              }
            ),
            !!d && !!v && /* @__PURE__ */ r(
              z,
              {
                pl: s.md,
                ml: "auto",
                mt: s.sm,
                children: /* @__PURE__ */ r(
                  A,
                  {
                    variant: "text",
                    size: "sm",
                    color: "grey.600",
                    children: `${typeof t == "string" && (t.length.toLocaleString() || 0)}/${d.toLocaleString()}`
                  }
                )
              }
            )
          ] })
        ]
      }
    );
  }
);
Ft.displayName = "CommonInput";
const ee = st((t, e) => /* @__PURE__ */ r(
  Ft,
  {
    ref: e,
    ...t
  }
));
ee.displayName = "Input";
const fo = st(
  ({ label: t = "", description: e = "", rows: o = 4, ...i }, n) => /* @__PURE__ */ g(z, { children: [
    /* @__PURE__ */ g(
      z,
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          !!t && /* @__PURE__ */ r(jt, { children: t }),
          !!e && /* @__PURE__ */ r(
            J,
            {
              text: !i.isDisabled && e || "",
              placement: "left",
              children: /* @__PURE__ */ r(z, { children: /* @__PURE__ */ r(b, { icon: It }) })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r(
      Ft,
      {
        ref: n,
        ...i,
        rows: o,
        isMultiline: !0
      }
    )
  ] })
);
fo.displayName = "Textarea";
const Da = st((t, e) => {
  const { children: o, role: i, ...n } = t, a = ue.toArray(o), l = a.length, c = mt(null), d = mr({
    count: l,
    estimateSize: () => 48,
    getScrollElement: () => c.current
  });
  return /* @__PURE__ */ r(m, { ref: e, children: /* @__PURE__ */ r(
    Ht,
    {
      ...n,
      ref: c,
      role: i,
      component: "div",
      children: /* @__PURE__ */ r(
        m,
        {
          sx: {
            position: "relative",
            height: d.getTotalSize()
          },
          children: d.getVirtualItems().map((p) => /* @__PURE__ */ r(
            m,
            {
              sx: {
                width: "100%",
                position: "absolute",
                transform: `translateY(${p.start}px)`
              },
              children: a[p.index]
            },
            p.key
          ))
        }
      )
    }
  ) });
}), Aa = B(nt)(({ theme: t }) => ({
  boxShadow: rt.lg,
  marginTop: t.spacing(s.lg),
  marginBottom: t.spacing(s.lg),
  padding: t.spacing(s.xs, s.none),
  borderRadius: t.rounding(y.md),
  border: `1px solid ${t.palette.grey[200]}`
})), uo = B(ye)(({ theme: t, color: e = void 0 }) => ({
  margin: t.spacing("1px", s.sm),
  // TODO: understand why this padding is not aligned to the DS spacings
  padding: "9px 10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: t.rounding(y.sm),
  minWidth: 120,
  gap: t.spacing(s.xs),
  color: e ?? t.palette.grey[700],
  "& span": {
    overflow: "hidden",
    textWrap: "nowrap",
    textOverflow: "ellipsis"
  },
  ...pt(t.palette.grey[500]),
  "& .MuiListItemButton-root": {
    ...pt("inherit")
  },
  "&:active, &:hover, &:focus-visible": {
    color: t.palette.grey[800],
    backgroundColor: `${t.palette.grey[50]} !important`
  },
  "&.Mui-disabled": {
    color: t.palette.grey[500],
    ...pt(t.palette.grey[400]),
    backgroundColor: "transparent",
    "& .MuiListItemButton-root": {
      ...pt("inherit")
    }
  },
  "&.Mui-selected": {
    backgroundColor: `${t.palette.grey[50]} !important`,
    "&:active, &:hover, &:focus-visible": {
      color: t.palette.grey[800],
      backgroundColor: `${t.palette.grey[50]} !important`
    }
  }
})), ho = B(Ot)({
  color: "inherit",
  lineHeight: "20px",
  display: "flex",
  flex: 1,
  overflow: "hidden"
}), re = B(Nt)({
  "& svg": {
    width: 16,
    height: 16
  },
  minWidth: "24px !important",
  overflow: "hidden"
}), xo = B(m)(({ theme: t }) => ({
  "& svg": {
    color: "inherit"
  },
  "& p": {
    width: 0,
    visibility: "hidden",
    display: "none"
  },
  maxWidth: "16px",
  padding: s.none,
  margin: s.none,
  width: 20,
  height: 24,
  display: "flex",
  alignItems: "center",
  alignSelf: "start",
  backgroundColor: "transparent !important",
  marginRight: t.spacing(s.md)
})), zt = ({ children: t }) => /* @__PURE__ */ r(xo, { children: /* @__PURE__ */ r(re, { tabIndex: -1, children: t }) }), vo = ({
  label: t,
  value: e,
  textColor: o = void 0,
  textFontSize: i = "14px",
  textFontWeight: n = void 0,
  icon: a = void 0,
  isDisabled: l = !1,
  hasDivider: c = !1,
  iconColor: d = void 0,
  withCheckbox: p = !1,
  withRadio: f = !1,
  isSelected: x = !1,
  IconComponent: h = void 0,
  maxWidth: v = void 0,
  onClick: w = void 0,
  hasOptionCheckIcon: S = !1,
  tooltip: k = void 0,
  maxTooltipWidth: L = void 0
}) => {
  const I = lt(), u = !f && !p && (!!a || !!h), F = n ?? I.typography.fontWeightMedium;
  return /* @__PURE__ */ g(Z, { children: [
    /* @__PURE__ */ g(
      uo,
      {
        disableRipple: !0,
        sx: { maxWidth: v },
        disabled: l,
        color: o,
        selected: p ? !1 : x,
        role: "listitem",
        onClick: w,
        children: [
          /* @__PURE__ */ g(
            m,
            {
              display: "flex",
              alignItems: "center",
              width: "100%",
              minWidth: 0,
              children: [
                !!p && !f && /* @__PURE__ */ r(zt, { children: /* @__PURE__ */ r(
                  Jt,
                  {
                    label: "checkbox",
                    checked: !!x,
                    size: "small"
                  }
                ) }),
                !!f && !p && /* @__PURE__ */ r(zt, { children: /* @__PURE__ */ r(
                  po,
                  {
                    checked: !!x,
                    size: "small",
                    label: "radio"
                  }
                ) }),
                !!u && /* @__PURE__ */ r(re, { children: h ?? (a && /* @__PURE__ */ r(
                  b,
                  {
                    icon: a,
                    style: { color: d ?? I.palette.grey[800] }
                  }
                )) }),
                /* @__PURE__ */ r(
                  ho,
                  {
                    sx: {
                      "& .MuiTypography-root": {
                        fontSize: i,
                        fontWeight: F
                      }
                    },
                    children: t
                  }
                )
              ]
            }
          ),
          !!k && /* @__PURE__ */ r(
            J,
            {
              ...k,
              placement: k.placement ?? "right",
              maxBodyWidth: L,
              children: /* @__PURE__ */ r(
                m,
                {
                  ...k.shouldHighlightChildIcon && {
                    sx: {
                      "&:hover": {
                        "& svg": {
                          color: `${I.palette.primary[700]} !important`
                        }
                      }
                    }
                  },
                  children: /* @__PURE__ */ r(
                    b,
                    {
                      icon: It,
                      style: {
                        color: I.palette.grey[700]
                      }
                    }
                  )
                }
              )
            }
          ),
          !!x && !!S && /* @__PURE__ */ r(
            b,
            {
              icon: ur,
              style: { color: I.palette.primary[600] }
            }
          )
        ]
      }
    ),
    !!c && /* @__PURE__ */ r(
      m,
      {
        my: s.xs,
        sx: {
          borderBottom: `1px solid ${I.palette.grey[200]}`
        }
      },
      `divider-${e}`
    )
  ] });
}, yo = M("div")(({ theme: t }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  padding: `${t.spacing(s.xl)} ${t.spacing(s["3xl"])}`,
  borderRadius: t.rounding(y.xl),
  border: `1px solid ${t.palette.grey[300]}`,
  backgroundColor: t.palette.common.white,
  cursor: "pointer",
  transition: "border-color 0.3s, border-width 0.3s, background-color 0.3s",
  userSelect: "none",
  "&:hover": {
    borderColor: t.palette.primary[600],
    borderWidth: "2px",
    backgroundColor: t.palette.primary[100]
  },
  "&:focus": {
    outline: "none",
    borderColor: t.palette.primary[600]
  },
  "&.active, &.focused, &.accept": {
    borderColor: t.palette.primary[600],
    borderWidth: "2px",
    backgroundColor: t.palette.primary[100]
  },
  "&.reject": {
    borderColor: t.palette.error.main,
    borderWidth: "2px",
    backgroundColor: "rgba(255, 236, 236, 0.5)"
  },
  "&.disabled": {
    cursor: "not-allowed",
    opacity: 0.6,
    "&:hover, &.active, &.focused, &.accept": {
      borderColor: t.palette.grey[300],
      borderWidth: "1px",
      backgroundColor: t.palette.common.white
    }
  }
})), bo = M(z)(({ theme: t }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: t.spacing(s.lg),
  fontSize: "1.5rem",
  color: t.palette.grey[800],
  border: `1px solid ${t.palette.grey[200]}`,
  padding: t.spacing(s.lg),
  borderRadius: t.rounding(y.md)
})), Co = M(z)(({ theme: t }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: t.spacing(s.xs)
})), wo = M(z)(({ theme: t }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: t.spacing(s.xs),
  marginBottom: t.spacing(s.xs)
})), So = M("span")(({ theme: t }) => ({
  color: t.palette.primary.main,
  fontWeight: t.typography.fontWeightBold,
  fontSize: t.typography.body2.fontSize,
  lineHeight: t.typography.body2.lineHeight,
  cursor: "pointer"
})), Io = me.forwardRef(
  ({
    accept: t,
    maxFiles: e = 1,
    maxSize: o,
    minSize: i,
    disabled: n = !1,
    onDrop: a,
    onDropAccepted: l,
    onDropRejected: c,
    hasNoClick: d = !1,
    hasNoDrag: p = !1,
    hasNoKeyboard: f = !1,
    supportingText: x = "PPTX file, up to 100 slides.",
    uploadButtonText: h = "Click to upload",
    dragAndDropText: v = "or drag and drop",
    icon: w = /* @__PURE__ */ r(b, { icon: Ae }),
    sx: S,
    multiple: k = !1
  }, L) => {
    const I = O(
      (K, E) => {
        n || a == null || a(K, E);
      },
      [a, n]
    ), C = ot(
      () => ({
        accept: t,
        maxFiles: e,
        maxSize: o,
        minSize: i,
        disabled: n,
        multiple: k,
        onDrop: I,
        onDropAccepted: l,
        onDropRejected: c,
        noClick: d,
        noDrag: p,
        noKeyboard: f
      }),
      [
        t,
        e,
        o,
        i,
        n,
        I,
        l,
        c,
        d,
        p,
        f,
        k
      ]
    ), { getRootProps: u, getInputProps: F, isDragActive: D, isFocused: P, isDragAccept: X, isDragReject: tt } = Qe(C), q = [
      D ? "active" : "",
      P ? "focused" : "",
      X ? "accept" : "",
      tt ? "reject" : "",
      n ? "disabled" : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ r(
      z,
      {
        sx: S,
        width: "100%",
        children: /* @__PURE__ */ g(
          yo,
          {
            ref: L,
            className: q || void 0,
            ...u(),
            "aria-disabled": n,
            children: [
              /* @__PURE__ */ r("input", { ...F() }),
              /* @__PURE__ */ r(bo, { children: w }),
              /* @__PURE__ */ g(Co, { children: [
                /* @__PURE__ */ g(wo, { children: [
                  /* @__PURE__ */ r(So, { children: h }),
                  /* @__PURE__ */ r(
                    A,
                    {
                      variant: "text",
                      size: "sm",
                      color: "text.secondary",
                      children: v
                    }
                  )
                ] }),
                !!x && /* @__PURE__ */ r(
                  A,
                  {
                    variant: "text",
                    size: "xs",
                    color: "text.secondary",
                    align: "center",
                    children: x
                  }
                )
              ] })
            ]
          }
        )
      }
    );
  }
);
Io.displayName = "FileUpload";
const Ea = M(hr.div)(({ theme: t }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  backgroundColor: t.palette.primary[50],
  zIndex: 0
})), Ba = M(z)(({ theme: t }) => ({
  display: "flex",
  flexDirection: "row",
  gap: t.spacing(s.lg),
  width: "100%",
  position: "relative",
  zIndex: 1,
  minWidth: 0
})), Ma = M(z)(() => ({
  minWidth: 150,
  maxWidth: 626,
  "& p": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
})), za = M(z)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  flexShrink: 0
})), Wa = M(z)(({ theme: t }) => ({
  display: "flex",
  flexDirection: "column",
  gap: t.spacing(s.xs),
  minWidth: 0
})), Ta = M(z)(({ theme: t }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: t.spacing(s.md)
})), Ra = M("div")(({ theme: t }) => ({
  width: "1px",
  height: "16px",
  backgroundColor: t.palette.grey[300]
})), Pa = M(z)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  gap: t.spacing(s.xs)
})), $a = M(z)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  gap: t.spacing(s.xs),
  marginLeft: "auto",
  // Push to right edge
  paddingLeft: t.spacing(s.xl)
})), ko = he({
  isPlaylist: !1,
  playlist: [],
  wasPlayed: !1,
  setWasPlayed: () => {
  },
  isAutoplayOn: !0,
  toggleAutoplay: () => {
  },
  videoIndex: 0,
  nextVideo: () => {
  },
  prevVideo: () => {
  },
  goToVideo: () => {
  }
}), Ha = () => xe(ko), Oa = (t = [], e = {}) => {
  const o = t.length > 0, [i, n] = N(!1), a = (C) => {
    n(C);
  }, l = new URLSearchParams(window.location.search).get("playlistAutoplay"), c = l ? !!JSON.parse(String(l).toLowerCase()) : void 0, d = typeof c < "u" ? c : !0, [p, f] = N(
    typeof e.isPlaylistAutoplayBehaviorOn < "u" ? e.isPlaylistAutoplayBehaviorOn : d
  ), x = () => {
    var C;
    (C = e.onAutoplayToggle) == null || C.call(e), f((u) => !u);
  }, h = new URLSearchParams(window.location.search).get("playlistVideoIndex"), v = h ? Number(h) : 0, [w, S] = N(v), k = () => {
    S((C) => {
      var F;
      const u = C > 0 ? C - 1 : t.length - 1;
      return (F = e.onPlaylistNav) == null || F.call(e, "prev", u), u;
    });
  }, L = () => {
    S((C) => {
      var F;
      const u = C < t.length - 1 ? C + 1 : 0;
      return (F = e.onPlaylistNav) == null || F.call(e, "next", u), u;
    });
  }, I = (C) => {
    var u;
    S(C), (u = e.onPlaylistNav) == null || u.call(e, C < w ? "prev" : "next", C);
  };
  return ft(() => {
    if (!o)
      return;
    const C = new URLSearchParams(window.location.search);
    C.set("playlistVideoIndex", w.toString()), C.set("playlistAutoplay", p.toString());
    const u = new URL(window.location.href);
    u.search = new URLSearchParams(C).toString(), window.history.replaceState({}, document.title, u.toString());
  }, [o, w, p]), {
    isPlaylist: o,
    playlist: t,
    wasPlayed: i,
    setWasPlayed: a,
    isAutoplayOn: typeof e.isAutoplay < "u" && typeof e.onAutoplayToggle < "u" ? e.isAutoplay : p,
    toggleAutoplay: x,
    videoIndex: w,
    nextVideo: L,
    prevVideo: k,
    goToVideo: I
  };
}, Fo = ({
  color: t,
  onClick: e,
  size: o,
  isSelected: i = !1
}) => /* @__PURE__ */ r(
  m,
  {
    onClick: e,
    "data-color": t,
    sx: (a) => ({
      width: o,
      height: o,
      backgroundColor: t,
      borderRadius: y.full,
      border: "2px solid",
      borderColor: "white",
      cursor: "pointer",
      boxShadow: `0px 0px 0px 2px ${i ? a.palette.primary[600] : a.palette.grey[200]}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }),
    children: !!(t === "#00000000" || t === "transparent") && /* @__PURE__ */ g(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "22",
        viewBox: "0 0 20 22",
        fill: "none",
        children: [
          /* @__PURE__ */ r(
            "path",
            {
              d: "M15.0391 4.59375L3.59375 16.0391C2.5 14.6328 1.875 12.875 1.875 11C1.875 6.50781 5.50781 2.875 10 2.875C11.875 2.875 13.6328 3.5 15.0391 4.59375ZM16.3672 5.92188C17.4609 7.32812 18.125 9.08594 18.125 11C18.125 15.4531 14.4531 19.125 10 19.125C8.08594 19.125 6.32812 18.4609 4.92188 17.3672L16.3672 5.92188ZM0 11C0 14.5547 1.875 17.8359 5 19.6328C8.08594 21.4297 11.875 21.4297 15 19.6328C18.0859 17.8359 20 14.5547 20 11C20 7.40625 18.0859 4.125 15 2.32812C11.875 0.53125 8.08594 0.53125 5 2.32812C1.875 4.125 0 7.40625 0 11Z",
              fill: "#98A2B3"
            }
          ),
          /* @__PURE__ */ r(
            "rect",
            {
              x: "16.4012",
              y: "3.24756",
              width: "1.87172",
              height: "19.9853",
              transform: "rotate(45.0574 16.4012 3.24756)",
              fill: "#F04438",
              fillOpacity: "0.8"
            }
          )
        ]
      }
    )
  }
), oe = B(T)(({ theme: t }) => ({
  position: "relative",
  backgroundColor: t.palette.common.white,
  gap: t.spacing(s.xl),
  width: 300
})), Lo = B(vr)(({ theme: t }) => ({
  display: "flex",
  flexDirection: "column",
  gap: t.spacing(s.xl),
  width: "100% !important",
  "& .react-colorful__saturation": {
    width: "100%",
    borderRadius: t.rounding(y.xxs),
    borderBottom: "none"
  },
  "& .react-colorful__alpha-pointer": {
    width: "16px",
    height: "16px"
  },
  "& .react-colorful__hue-pointer ": {
    width: "24px",
    height: "24px",
    borderWidth: "3px"
  },
  "& .react-colorful__saturation-pointer": {
    width: "16px",
    height: "16px",
    borderWidth: "2px"
  },
  "& .react-colorful__hue": {
    height: "16px",
    borderRadius: y.full,
    margin: t.spacing(0, s.xl)
  },
  "& .react-colorful__alpha": {
    height: "16px",
    borderRadius: y.full,
    margin: t.spacing(0, s.xl)
  }
})), Do = B(yr)(({ theme: t }) => ({
  margin: t.spacing(s.none),
  borderRadius: t.rounding(y.md),
  border: `1px solid ${t.palette.grey[300]}`,
  padding: t.spacing(s.md, s.lg),
  width: "100%"
})), Ao = B(T)(({ theme: t }) => ({
  gap: t.spacing(s.md),
  padding: t.spacing(0, s.xl),
  width: "100%"
})), Eo = B("input")(({ theme: t }) => ({
  padding: t.spacing(s.md, s.lg),
  borderRadius: t.rounding(y.md),
  border: `1px solid ${t.palette.grey[300]}`,
  width: "60px"
})), Bo = ({ color: t, onColorChange: e }) => {
  const o = br(t, 200), i = mt(null), { open: n, isSupported: a } = Cr(), l = Sr(t), c = (x) => {
    const h = x.target.value.replace("%", ""), v = parseInt(h || "100", 10);
    if (!Number.isNaN(v) && v >= 0 && v <= 100) {
      const w = Et(t, v);
      e(w);
    }
  }, d = O(
    (x) => {
      const h = Math.min(100, Math.max(0, l + x)), v = Et(t, h);
      e(v);
    },
    [t, l, e]
  ), p = O(() => document.activeElement === i.current, [i]), f = O(() => {
    if (!a()) {
      console.warn("EyeDropper API not supported in this browser");
      return;
    }
    (async () => {
      try {
        const h = await n();
        e(h.sRGBHex);
      } catch (h) {
        console.error("Error using eye dropper:", h);
      }
    })();
  }, [n, a, e]);
  return At(
    "up",
    () => {
      d(5);
    },
    {
      preventDefault: !0,
      enabled: p,
      enableOnFormTags: ["input"],
      scopes: ["color-picker"]
    },
    [d]
  ), At(
    "down",
    () => {
      d(-5);
    },
    {
      preventDefault: !0,
      enabled: p,
      enableOnFormTags: ["input"],
      scopes: ["color-picker"]
    },
    [d]
  ), /* @__PURE__ */ g(oe, { children: [
    /* @__PURE__ */ r(
      Lo,
      {
        color: t,
        onChange: e
      }
    ),
    /* @__PURE__ */ g(Ao, { direction: "row", children: [
      /* @__PURE__ */ r(
        Do,
        {
          color: o,
          onChange: e,
          prefixed: !0,
          alpha: !0
        }
      ),
      /* @__PURE__ */ g(
        T,
        {
          direction: "row",
          alignItems: "center",
          gap: s.xs,
          children: [
            /* @__PURE__ */ r(
              Eo,
              {
                ref: i,
                type: "text",
                value: `${l}%`,
                onChange: c,
                "aria-label": "Alpha opacity percentage"
              }
            ),
            a() && /* @__PURE__ */ r(
              be,
              {
                onClick: f,
                size: "small",
                color: "secondary",
                "aria-label": "Pick color from screen",
                children: /* @__PURE__ */ r(
                  b,
                  {
                    icon: Ee,
                    size: "sm"
                  }
                )
              }
            )
          ]
        }
      )
    ] })
  ] });
}, ie = ({ onOpen: t, onClose: e } = {}) => {
  const [o, i] = N(null), n = O(
    (l) => {
      i(o ? null : l.currentTarget), o ? e == null || e() : t == null || t();
    },
    [o, e, t]
  ), a = O(() => {
    i(null), e == null || e();
  }, [e]);
  return Zt(() => {
    o && a();
  }), {
    anchorEl: o,
    setAnchorEl: i,
    isOpen: !!o,
    handleOpen: n,
    handleClose: a
  };
}, Mo = B(nt)(({ theme: t }) => ({
  borderRadius: t.rounding(y.lg)
})), zo = B(m)(({ theme: t }) => ({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  gap: t.spacing(s.md)
})), Wo = B(m)(({ theme: t }) => ({
  display: "flex",
  flexDirection: "column",
  marginLeft: t.spacing(s.xl),
  marginRight: t.spacing(s.xl),
  gap: t.spacing(s.md)
})), To = 24, Na = ({
  color: t,
  presetColors: e,
  onColorChange: o,
  headerTitle: i,
  children: n,
  popperPlacement: a = "left-start",
  popperOffset: l = [0, 20],
  withHeader: c = !1,
  onOpen: d,
  onClose: p,
  bounds: f = "window",
  initialPosition: x = { x: 0, y: 0 },
  disablePortal: h = !1,
  zIndex: v = 9999
}) => {
  const [w, S] = N(x), k = ot(() => {
    try {
      return bt(t);
    } catch (E) {
      return console.error(E), "#000000";
    }
  }, [t]), L = ot(() => {
    try {
      return Ir(f);
    } catch (E) {
      return console.error(E), "window";
    }
  }, [f]), { anchorEl: I, handleOpen: C, handleClose: u, isOpen: F } = ie({
    onClose: p,
    onOpen: d
  }), D = c, P = O(
    (E) => {
      try {
        const H = bt(E);
        o(H);
      } catch (H) {
        console.error(H);
      }
    },
    [o]
  ), X = O((E, H) => {
    S({ x: H.x, y: H.y });
  }, []), tt = O(
    (E) => {
      P(E);
    },
    [P]
  ), q = O(
    (E) => /* @__PURE__ */ r(
      Fo,
      {
        color: E,
        onClick: () => {
          tt(E);
        },
        isSelected: E.toLowerCase() === k.toLowerCase(),
        size: To
      },
      E
    ),
    [k, tt]
  ), K = O(
    () => {
      var E, H;
      return /* @__PURE__ */ r(
        ut,
        {
          onClickAway: u,
          mouseEvent: "onMouseDown",
          children: /* @__PURE__ */ g(m, { borderRadius: y.md, children: [
            !!c && /* @__PURE__ */ g(
              T,
              {
                p: s.md,
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                className: "header-drag-handle",
                sx: (j) => ({
                  cursor: D ? "move" : "default",
                  borderTopLeftRadius: j.rounding(y.md),
                  borderTopRightRadius: j.rounding(y.md)
                }),
                children: [
                  /* @__PURE__ */ g(
                    T,
                    {
                      direction: "row",
                      alignItems: "center",
                      gap: s.lg,
                      children: [
                        /* @__PURE__ */ r(
                          b,
                          {
                            icon: Be,
                            style: {
                              color: (E = Bt.grey) == null ? void 0 : E[600]
                            }
                          }
                        ),
                        !!i && /* @__PURE__ */ r(
                          A,
                          {
                            variant: "text",
                            size: "sm",
                            fontWeight: "semibold",
                            color: "grey.950",
                            children: i
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ r(
                    b,
                    {
                      onClick: u,
                      icon: Ut,
                      style: {
                        color: (H = Bt.grey) == null ? void 0 : H[800],
                        cursor: "pointer"
                      }
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ g(
              oe,
              {
                pb: s.xl,
                sx: (j) => ({
                  borderBottomRightRadius: j.rounding(y.md),
                  borderBottomLeftRadius: j.rounding(y.md)
                }),
                children: [
                  /* @__PURE__ */ r(
                    Bo,
                    {
                      color: k,
                      onColorChange: P
                    }
                  ),
                  e.map(({ colors: j, title: dt }) => /* @__PURE__ */ g(Wo, { children: [
                    /* @__PURE__ */ r(
                      A,
                      {
                        variant: "text",
                        size: "sm",
                        fontWeight: "medium",
                        children: dt
                      }
                    ),
                    /* @__PURE__ */ r(zo, { children: j.map((xt) => {
                      try {
                        const it = bt(xt);
                        return q(it);
                      } catch {
                        return null;
                      }
                    }).filter(Boolean) })
                  ] }, dt))
                ]
              }
            )
          ] })
        }
      );
    },
    [
      c,
      D,
      i,
      u,
      k,
      P,
      e,
      q
    ]
  );
  return /* @__PURE__ */ r(wr, { initiallyActiveScopes: ["color-picker"], children: /* @__PURE__ */ g(m, { children: [
    /* @__PURE__ */ r(m, { onClick: C, children: n }),
    /* @__PURE__ */ r(
      ht,
      {
        disablePortal: h,
        anchorEl: I,
        open: F,
        sx: { zIndex: v },
        placement: a,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: l
            }
          },
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport"
            }
          }
        ],
        children: /* @__PURE__ */ r("div", { style: { width: "100%", height: "100%", position: "relative" }, children: /* @__PURE__ */ r(
          xr,
          {
            dragHandleClassName: "header-drag-handle",
            enableResizing: !1,
            bounds: L,
            disableDragging: !D,
            onDragStop: X,
            position: w,
            style: { zIndex: v, position: "relative" },
            children: /* @__PURE__ */ r(
              Mo,
              {
                elevation: 5,
                "data-testid": "color-picker",
                children: K()
              }
            )
          }
        ) })
      }
    )
  ] }) });
}, _a = "draggable-handle", Ro = 32, Va = M(nt)(({ theme: t }) => ({
  position: "fixed",
  zIndex: 1e3,
  minWidth: 280,
  backgroundColor: t.palette.background.paper,
  borderRadius: t.rounding(y.xl),
  border: "1px solid",
  borderColor: t.palette.grey[300]
})), Ua = M(m, {
  shouldForwardProp: (t) => t !== "isDraggable"
})(({ isDraggable: t, theme: e }) => ({
  cursor: t ? "move" : "default",
  display: t ? "flex" : "none",
  alignItems: "center",
  "&:hover": {
    color: e.palette.primary[700]
  }
})), Ga = M(m)({
  position: "absolute",
  top: 4,
  right: 4,
  zIndex: 2e3,
  display: "flex",
  alignItems: "center",
  gap: 4,
  height: Ro
});
M(m, {
  shouldForwardProp: (t) => t !== "theme"
})(({ theme: t }) => ({
  padding: t.spacing(s.xl, s["2xl"]),
  position: "absolute",
  top: 0,
  left: 0,
  height: 50
}));
const ja = M(m, {
  shouldForwardProp: (t) => t !== "theme"
})(({ theme: t }) => ({
  position: "relative",
  borderBottomLeftRadius: t.rounding(y.xl),
  borderBottomRightRadius: t.rounding(y.xl),
  display: "flex",
  flexDirection: "column"
})), Za = M(m, {
  shouldForwardProp: (t) => t !== "theme"
})(({ theme: t }) => ({
  padding: t.spacing(s.none, s["2xl"]),
  marginBottom: 50
})), Xa = M(m, {
  shouldForwardProp: (t) => t !== "theme"
})(({ theme: t }) => ({
  padding: t.spacing(s.lg, s["2xl"]),
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  gap: t.spacing(s.md),
  border: "1px solid",
  borderColor: t.palette.grey[200],
  backgroundColor: t.palette.grey[50],
  borderBottomLeftRadius: t.rounding(y.xl),
  borderBottomRightRadius: t.rounding(y.xl),
  position: "absolute",
  bottom: 0,
  left: 0,
  height: 50
})), Po = Y(
  ({
    aiActions: t,
    getActionHandler: e,
    isActionEnabled: o,
    isCopyDisabled: i
  }) => /* @__PURE__ */ r(Z, { children: t.map((n) => {
    const a = n.isAlwaysEnabled ?? o(n.id), l = n.id === "copy" && i || !a, c = n.tooltip;
    return /* @__PURE__ */ r(
      J,
      {
        title: c,
        shouldHighlightChildIcon: !1,
        children: /* @__PURE__ */ r(m, { sx: { display: "inherit" }, children: /* @__PURE__ */ r(
          ct,
          {
            variant: "text",
            color: "secondary",
            label: n.id,
            onClick: e(n),
            size: "medium",
            "data-testid": n.id,
            disabled: l,
            disableBackground: !0,
            children: /* @__PURE__ */ r(b, { icon: n.icon })
          }
        ) })
      },
      n.id
    );
  }) })
);
Po.displayName = "ActionButtons";
const $o = Y(
  ({
    isLoading: t,
    text: e,
    error: o,
    isWriting: i,
    onWritingComplete: n
  }) => t ? /* @__PURE__ */ r(kr, { thickness: 4 }) : !e || o ? /* @__PURE__ */ g(
    T,
    {
      gap: s.lg,
      alignItems: "flex-start",
      justifyContent: "flex-start",
      direction: "row",
      children: [
        /* @__PURE__ */ r(m, { color: "error.600", children: /* @__PURE__ */ r(
          b,
          {
            icon: Me,
            size: "lg"
          }
        ) }),
        /* @__PURE__ */ r(
          A,
          {
            variant: "text",
            size: "sm",
            color: "grey.900",
            children: "No content available, please regenerate."
          }
        )
      ]
    }
  ) : i ? /* @__PURE__ */ r(
    Fr,
    {
      text: e,
      onComplete: n,
      variant: "text",
      size: "sm",
      loadingOptions: {
        thickness: 4
      }
    }
  ) : /* @__PURE__ */ g(
    A,
    {
      variant: "text",
      size: "sm",
      children: [
        /* @__PURE__ */ r(Lr, { text: e }),
        /* @__PURE__ */ r("br", {}),
        /* @__PURE__ */ r("br", {})
      ]
    }
  )
);
$o.displayName = "ResultContent";
const Ho = M(Ht, {
  shouldForwardProp: (t) => t !== "theme"
})(({ theme: t }) => ({
  padding: t.spacing(s.xl)
})), Oo = M(Ce, {
  shouldForwardProp: (t) => t !== "theme"
})(({ theme: t }) => ({
  padding: t.spacing(s.sm),
  borderRadius: t.rounding(y.md),
  "&:hover": {
    backgroundColor: t.palette.grey[100]
  }
})), No = B(nt)(({ theme: t }) => ({
  minWidth: 280,
  backgroundColor: t.palette.background.paper,
  borderRadius: t.rounding(y.xl),
  border: "1px solid",
  borderColor: t.palette.grey[300],
  boxShadow: t.shadows[5]
})), _o = B(m)(({ theme: t }) => ({
  position: "relative",
  display: "inline-flex",
  zIndex: 2,
  marginLeft: "auto",
  paddingLeft: t.spacing(s.md),
  pointerEvents: "all"
})), Vo = ({
  item: {
    label: t,
    icon: e,
    onClick: o,
    subOptions: i,
    disabled: n,
    upgradeButton: a,
    iconColor: l = "primary",
    disabledTooltipProps: c = void 0,
    ...d
  },
  level: p = 0,
  onSubMenuOpen: f = void 0,
  onSubMenuClose: x = void 0
}) => {
  const { anchorEl: h, isOpen: v, handleOpen: w, handleClose: S } = ie(), k = (D) => {
    n || (i != null && i.length ? (w(D), f == null || f()) : o == null || o());
  };
  Zt(() => {
    S(), x == null || x();
  });
  const I = (D) => {
    var P;
    D.stopPropagation(), (P = a == null ? void 0 : a.buttonProps) != null && P.onClick && a.buttonProps.onClick(D);
  }, C = () => n && a ? /* @__PURE__ */ r(_o, { onClick: I, children: /* @__PURE__ */ r(
    io,
    {
      disabledTooltipProps: a.disabledTooltipProps,
      tooltipProps: a.tooltipProps,
      buttonProps: {
        ...a.buttonProps,
        onClick: I
      }
    }
  ) }) : null, u = () => i != null && i.length && !n ? /* @__PURE__ */ r(
    b,
    {
      icon: Ge,
      color: "grey.800"
    }
  ) : null;
  return /* @__PURE__ */ g(Z, { children: [
    /* @__PURE__ */ g(
      Oo,
      {
        onClick: k,
        role: "menuitem",
        "aria-disabled": n ? "true" : "false",
        disabled: n,
        sx: {
          position: "relative",
          "&.Mui-disabled": {
            opacity: 0.7,
            pointerEvents: "auto",
            cursor: "default",
            "&:hover": {
              backgroundColor: "transparent"
            }
          }
        },
        ...d,
        children: [
          !!e && /* @__PURE__ */ r(
            Nt,
            {
              sx: {
                minWidth: 30,
                color: l === "primary" ? n ? "primary.400" : "primary.700" : n ? "grey.400" : "grey.800"
              },
              children: /* @__PURE__ */ r(b, { icon: e })
            }
          ),
          /* @__PURE__ */ r(J, { ...n ? c : {}, children: /* @__PURE__ */ r(
            Ot,
            {
              primary: /* @__PURE__ */ r(
                A,
                {
                  variant: "text",
                  size: "sm",
                  fontWeight: "medium",
                  color: n ? "grey.400" : "grey.700",
                  children: t
                }
              )
            }
          ) }),
          C(),
          u()
        ]
      }
    ),
    !!(i != null && i.length) && !n && /* @__PURE__ */ r(
      ht,
      {
        open: v,
        anchorEl: h,
        placement: "right",
        sx: { zIndex: 1300 },
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 20]
            }
          }
        ],
        children: /* @__PURE__ */ r(ut, { onClickAway: S, children: /* @__PURE__ */ r(No, { children: /* @__PURE__ */ r(Ho, { children: i.map((D) => /* @__PURE__ */ r(
          Vo,
          {
            item: D,
            level: p + 1,
            onSubMenuOpen: f,
            onSubMenuClose: x
          },
          D.label
        )) }) }) })
      }
    )
  ] });
}, Uo = ({
  values: t,
  onEdit: e,
  onDelete: o,
  getValueLabel: i,
  shouldWrapWithSpacing: n = !1,
  badgeMaxWidth: a = void 0,
  badgesColorPalette: l
}) => t.map((c) => {
  const d = i ? i(c) : typeof c == "string" ? c : "", p = l == null ? void 0 : l[d], f = p ? "filled" : "outlined";
  return /* @__PURE__ */ r(
    m,
    {
      sx: {
        ...n && {
          pt: s.md,
          pl: s.md
        },
        display: "flex",
        maxWidth: a
      },
      children: /* @__PURE__ */ r(
        no,
        {
          label: d,
          variant: f,
          color: p,
          size: "small",
          ...e && {
            onClick: () => {
              e(c);
            }
          },
          ...o && {
            onDelete: () => {
              o(c);
            }
          }
        }
      )
    },
    d
  );
}), Go = B(nt)(({ theme: t }) => ({
  boxShadow: rt.lg,
  marginTop: t.spacing(s.xs),
  padding: t.spacing(s.md),
  borderRadius: t.rounding(y.md),
  border: `1px solid ${t.palette.grey[200]}`
})), Wt = 500, qa = ({
  anchorElement: t,
  onClose: e,
  canOverflowParent: o = !1,
  ...i
}) => /* @__PURE__ */ r(
  ht,
  {
    anchorEl: t,
    open: !0,
    transition: !0,
    disablePortal: !o,
    sx: (n) => ({ zIndex: o ? n.zIndex.modal + 1 : 2 }),
    children: ({ TransitionProps: n }) => /* @__PURE__ */ r(_t, { ...n, children: /* @__PURE__ */ r(Go, { children: /* @__PURE__ */ r(ut, { onClickAway: e, children: /* @__PURE__ */ r(
      T,
      {
        direction: "row",
        sx: {
          mt: -s.md,
          ml: -s.md,
          flexWrap: "wrap",
          width: "100%",
          maxWidth: Wt
        },
        children: /* @__PURE__ */ r(
          Uo,
          {
            ...i,
            shouldWrapWithSpacing: !0,
            badgeMaxWidth: Wt
          }
        )
      }
    ) }) }) })
  }
), jo = (t) => {
  const e = t.getIsPinned();
  return e ? {
    clipPath: "inset(0 -100px 0 0)",
    left: e === "left" ? `${t.getStart("left")}px` : void 0,
    position: "sticky"
  } : {};
}, Ka = 100, Tt = {
  headerCellSeparator: "Separator",
  isHorizontalScroll: "IsHorizontalScroll",
  isVerticalScroll: "IsVerticalScroll",
  pinnedColumn: "LeftPinned",
  lastPinnedColumn: "LastLeftPinned"
}, Zo = (t) => {
  const e = t.getIsPinned(), o = e === "left" && t.getIsLastColumn("left");
  return e ? {
    className: `${Tt.pinnedColumn} ${o ? Tt.lastPinnedColumn : ""}`
  } : {};
}, ne = (t) => !!t.isPlaceholderRow, Xo = ({
  getValueLabel: t,
  value: e
}) => t ? t(e) : typeof e == "string" ? e : "", Rt = [
  W.error,
  W.indigo,
  W.pink,
  W.primary,
  W.purple,
  W.rose,
  W.success,
  W.warning
], qo = (t) => {
  const e = 2166136261n, o = 16777619n, n = Array.from(t).reduce((a, l) => (a ^ BigInt(l.charCodeAt(0))) * o, e) & BigInt(4294967295);
  return Number(n);
}, Ya = ({
  getValueLabel: t,
  possibleValues: e
}) => {
  const o = Rt.length, i = e.map((n) => {
    const a = Xo({
      value: n,
      getValueLabel: t
    }), c = qo(a) % o;
    return [a, Rt[c]];
  });
  return Object.fromEntries(i);
}, Ko = ({ cell: t }) => {
  const [e, o] = N(!1), i = ne(t.row.original);
  return /* @__PURE__ */ g(
    we,
    {
      onMouseEnter: () => {
        o(!0);
      },
      onMouseLeave: () => {
        o(!1);
      },
      sx: {
        width: `var(--column-${t.column.id}-size)`,
        ...jo(t.column)
      },
      ...Zo(t.column),
      children: [
        !!i && /* @__PURE__ */ r(
          m,
          {
            sx: {
              position: "relative",
              height: "100%",
              overflow: "hidden"
            },
            children: /* @__PURE__ */ r(
              m,
              {
                sx: {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  left: 0,
                  height: "1px",
                  backgroundColor: "grey.200"
                }
              }
            )
          }
        ),
        Dr(t.column.columnDef.cell, { ...t.getContext(), isHovered: e })
      ]
    }
  );
}, Yo = ({ row: t }) => {
  const e = ne(t.original);
  return /* @__PURE__ */ r(
    Se,
    {
      sx: {
        ...e && {
          height: "100%",
          "& .MuiTableCell-root": {
            padding: "0px !important",
            border: "none !important",
            backgroundColor: "white !important"
          }
        }
      },
      children: t.getVisibleCells().map((o) => /* @__PURE__ */ r(
        Ko,
        {
          cell: o
        },
        o.id
      ))
    },
    t.id
  );
}, Jo = ({ tableController: t }) => /* @__PURE__ */ r(Ie, { children: t.getRowModel().rows.map((e) => /* @__PURE__ */ r(
  Yo,
  {
    row: e
  },
  e.id
)) }), Ja = Y(Jo, (t, e) => e.tableController.getState().columnSizingInfo.isResizingColumn ? t.tableController.options.data === e.tableController.options.data : !1), Qo = B(nt)(({ theme: t }) => ({
  boxShadow: rt.lg,
  marginTop: t.spacing(s.xs),
  paddingTop: t.spacing(s.xl),
  borderRadius: t.rounding(y.md),
  border: `1px solid ${t.palette.grey[200]}`,
  width: 280,
  overflowY: "hidden"
})), Qa = ({
  anchorElement: t,
  onClose: e,
  selectedOptions: o,
  onChange: i,
  options: n,
  search: a = void 0,
  setSearch: l = void 0,
  isClientFiltering: c = !0,
  isLoading: d = !1,
  shouldDisplayNoOptionsLabel: p = !0,
  addValueLabel: f = "",
  onClickAddValue: x = void 0,
  width: h = void 0
}) => {
  const v = lt(), [w, S] = N("");
  ft(() => {
    a && S(a);
  }, [a]);
  const k = ot(() => c ? ke()(n, { inputValue: w, getOptionLabel: (D) => D.label }) : n, [c, n, w]), L = ot(() => o.map((u) => u.value), [o]), I = (u) => {
    const F = L.includes(u.value) ? "remove" : "add", D = F === "remove" ? o.filter((P) => P.value !== u.value) : [...o, u];
    i(D, { action: F, option: u });
  }, C = O((u) => {
    u == null || u.focus();
  }, []);
  return /* @__PURE__ */ r(
    ht,
    {
      anchorEl: t,
      open: !0,
      transition: !0,
      disablePortal: !0,
      sx: { zIndex: 2 },
      placement: "bottom-start",
      children: ({ TransitionProps: u }) => /* @__PURE__ */ r(_t, { ...u, children: /* @__PURE__ */ r(Qo, { sx: { width: h }, children: /* @__PURE__ */ r(ut, { onClickAway: e, children: /* @__PURE__ */ g(T, { spacing: s.lg, children: [
        /* @__PURE__ */ r(
          T,
          {
            px: s.xl,
            sx: {
              "& .MuiInputBase-root": {
                py: "9px",
                px: "13px",
                ...v.typography.body1
              }
            },
            children: /* @__PURE__ */ r(
              ee,
              {
                ref: C,
                value: w,
                onChange: (F) => {
                  const D = F.target.value;
                  S(D), l == null || l(D);
                },
                placeholder: "Search",
                startIcon: /* @__PURE__ */ r(b, { icon: fr }),
                endAdornment: !!d && /* @__PURE__ */ r(
                  Xt,
                  {
                    size: 20,
                    label: "Search"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ g(
          Fe,
          {
            disablePadding: !0,
            role: "list",
            sx: {
              overflowY: "auto",
              maxHeight: "240px",
              pb: s.xs
            },
            children: [
              !!f && !!x && /* @__PURE__ */ r(
                T,
                {
                  role: "listitem",
                  sx: {
                    "& button": {
                      px: s.xl,
                      justifyContent: "flex-start",
                      "& .MuiButton-icon": {
                        marginRight: "8px"
                      },
                      "& svg": { width: "16px", height: "16px" }
                    }
                  },
                  children: /* @__PURE__ */ r(
                    Qr,
                    {
                      fullWidth: !0,
                      startIcon: /* @__PURE__ */ r(b, { icon: Ar }),
                      size: "small",
                      onClick: x,
                      children: f
                    }
                  )
                }
              ),
              !k.length && !!p && /* @__PURE__ */ r(T, { sx: { px: s.xl, py: s.xs }, children: /* @__PURE__ */ r(
                A,
                {
                  size: "sm",
                  variant: "text",
                  color: "grey.500",
                  children: "No options"
                }
              ) }),
              k.map((F) => {
                const D = L.includes(F.value);
                return /* @__PURE__ */ r(
                  vo,
                  {
                    value: String(F.value),
                    label: /* @__PURE__ */ r(
                      m,
                      {
                        sx: {
                          "& p": {
                            wordBreak: "break-word",
                            whiteSpace: "normal"
                          }
                        },
                        children: /* @__PURE__ */ r(
                          A,
                          {
                            size: "sm",
                            fontWeight: "medium",
                            variant: "text",
                            children: F.label
                          }
                        )
                      }
                    ),
                    onClick: () => {
                      I(F);
                    },
                    withCheckbox: !0,
                    isSelected: D
                  },
                  F.value
                );
              })
            ]
          }
        )
      ] }) }) }) })
    }
  );
}, ti = () => /* @__PURE__ */ g(
  "svg",
  {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r(
        "rect",
        {
          y: "0.129883",
          width: "40",
          height: "40",
          rx: "20",
          fill: "white"
        }
      ),
      /* @__PURE__ */ r(
        "mask",
        {
          id: "mask0_13579_120156",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "40",
          height: "41",
          children: /* @__PURE__ */ r(
            "rect",
            {
              y: "0.129883",
              width: "40",
              height: "40",
              fill: "#944E4E"
            }
          )
        }
      ),
      /* @__PURE__ */ g("g", { mask: "url(#mask0_13579_120156)", children: [
        /* @__PURE__ */ r(
          "rect",
          {
            x: "9.29395",
            y: "31.8135",
            width: "24.6195",
            height: "4.75112",
            rx: "2.37556",
            transform: "rotate(-45 9.29395 31.8135)",
            fill: "url(#paint0_linear_13579_120156)"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M33.9473 10.3251C34.1816 10.2705 34.3919 10.4808 34.3372 10.7151L33.2142 15.53C33.195 15.6124 33.2087 15.6991 33.2525 15.7716L35.8084 20.0038C35.9328 20.2097 35.7978 20.4747 35.5581 20.4951L30.6318 20.915C30.5474 20.9222 30.4692 20.962 30.4138 21.026L27.1786 24.7647C27.0211 24.9466 26.7274 24.9001 26.6339 24.6784L24.7123 20.123C24.6794 20.045 24.6173 19.9829 24.5393 19.95L19.9839 18.0284C19.7622 17.9349 19.7157 17.6412 19.8976 17.4838L23.6363 14.2485C23.7003 14.1931 23.7402 14.1149 23.7474 14.0306L24.1672 9.10429C24.1876 8.86457 24.4526 8.72956 24.6585 8.85394L28.8908 11.4099C28.9632 11.4536 29.0499 11.4674 29.1324 11.4481L33.9473 10.3251Z",
            fill: "#FED243"
          }
        ),
        /* @__PURE__ */ r(
          "mask",
          {
            id: "mask1_13579_120156",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "19",
            y: "8",
            width: "17",
            height: "17",
            children: /* @__PURE__ */ r(
              "path",
              {
                d: "M33.9473 10.3251C34.1816 10.2705 34.3919 10.4808 34.3372 10.7151L33.2142 15.53C33.195 15.6124 33.2087 15.6991 33.2525 15.7716L35.8084 20.0038C35.9328 20.2097 35.7978 20.4747 35.5581 20.4951L30.6318 20.915C30.5474 20.9222 30.4692 20.962 30.4138 21.026L27.1786 24.7647C27.0211 24.9466 26.7274 24.9001 26.6339 24.6784L24.7123 20.123C24.6794 20.045 24.6173 19.9829 24.5393 19.95L19.9839 18.0284C19.7622 17.9349 19.7157 17.6412 19.8976 17.4838L23.6363 14.2485C23.7003 14.1931 23.7402 14.1149 23.7474 14.0306L24.1672 9.10429C24.1876 8.86457 24.4526 8.72956 24.6585 8.85394L28.8908 11.4099C28.9632 11.4536 29.0499 11.4674 29.1324 11.4481L33.9473 10.3251Z",
                fill: "#FED243"
              }
            )
          }
        ),
        /* @__PURE__ */ r("g", { mask: "url(#mask1_13579_120156)", children: /* @__PURE__ */ r("g", { filter: "url(#filter0_f_13579_120156)", children: /* @__PURE__ */ r(
          "rect",
          {
            x: "9.29395",
            y: "31.8135",
            width: "24.6195",
            height: "4.75112",
            rx: "2.37556",
            transform: "rotate(-45 9.29395 31.8135)",
            fill: "url(#paint1_linear_13579_120156)",
            fillOpacity: "0.6"
          }
        ) }) }),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M17.3082 7.60757L19.7636 7.01136L19.212 9.47715C19.1665 9.68077 19.2022 9.89413 19.3117 10.0718L20.6375 12.2227L18.122 12.4601C17.9142 12.4797 17.7224 12.5797 17.5873 12.7387L15.9513 14.6643L14.9481 12.3452L14.4892 12.5437L14.9481 12.3452C14.8653 12.1537 14.7109 12.0021 14.518 11.9228L14.3278 12.3852L14.518 11.9228L12.1811 10.9619L14.0767 9.29122C14.2332 9.15326 14.3297 8.95961 14.3455 8.75156L14.5372 6.23212L16.7119 7.51866C16.8915 7.62491 17.1054 7.65681 17.3082 7.60757ZM16.0788 14.9591L16.0786 14.9587L16.0788 14.9591ZM11.884 10.8397C11.8841 10.8398 11.8842 10.8398 11.8843 10.8399L11.884 10.8397ZM14.2607 6.06856L14.261 6.06871C14.2609 6.06866 14.2608 6.06861 14.2607 6.06856L14.3624 5.89667L14.2607 6.06856Z",
            fill: "#FED243",
            fillOpacity: "0.8",
            stroke: "#FED243"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M9.18451 16.2256L8.73188 16.2759L9.18451 16.2256L9.02873 14.8231L10.3555 15.3039C10.5517 15.375 10.7678 15.3666 10.9579 15.2806L12.2437 14.6991L12.1965 16.1095C12.1895 16.318 12.2642 16.521 12.4047 16.6752L13.3552 17.7184L11.9992 18.1093C11.7987 18.1671 11.6287 18.3009 11.5254 18.4822L10.8271 19.7084L10.0363 18.5396L9.62218 18.8198L10.0363 18.5396C9.91938 18.3668 9.73959 18.2465 9.53524 18.2043L8.15319 17.919L9.02044 16.8058C9.14867 16.6412 9.20754 16.433 9.18451 16.2256Z",
            fill: "#FED243",
            fillOpacity: "0.5",
            stroke: "#FED243"
          }
        )
      ] }),
      /* @__PURE__ */ g("defs", { children: [
        /* @__PURE__ */ g(
          "filter",
          {
            id: "filter0_f_13579_120156",
            x: "2.27832",
            y: "7.38867",
            width: "34.7998",
            height: "34.8008",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ r(
                "feFlood",
                {
                  floodOpacity: "0",
                  result: "BackgroundImageFix"
                }
              ),
              /* @__PURE__ */ r(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              ),
              /* @__PURE__ */ r(
                "feGaussianBlur",
                {
                  stdDeviation: "4",
                  result: "effect1_foregroundBlur_13579_120156"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ g(
          "linearGradient",
          {
            id: "paint0_linear_13579_120156",
            x1: "33.6565",
            y1: "34.0816",
            x2: "9.20673",
            y2: "34.426",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ r(
                "stop",
                {
                  offset: "0.0357612",
                  stopColor: "#830000"
                }
              ),
              /* @__PURE__ */ r(
                "stop",
                {
                  offset: "1",
                  stopColor: "#CB0000"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ g(
          "linearGradient",
          {
            id: "paint1_linear_13579_120156",
            x1: "33.6565",
            y1: "34.0816",
            x2: "9.20673",
            y2: "34.426",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ r(
                "stop",
                {
                  offset: "0.0357612",
                  stopColor: "#830000"
                }
              ),
              /* @__PURE__ */ r(
                "stop",
                {
                  offset: "1",
                  stopColor: "#CB0000"
                }
              )
            ]
          }
        )
      ] })
    ]
  }
), ei = ({ description: t = "", isStepsGenerating: e, progress: o = 0 }) => {
  const i = e ? "Typing ..." : t.slice(0, t.length / 100 * o);
  return /* @__PURE__ */ g(
    T,
    {
      direction: "row",
      spacing: s.lg,
      mb: 2,
      minHeight: 55,
      alignItems: "flex-start",
      position: "relative",
      children: [
        /* @__PURE__ */ r(
          m,
          {
            position: "absolute",
            left: -50,
            children: /* @__PURE__ */ r(ti, {})
          }
        ),
        /* @__PURE__ */ g(
          m,
          {
            sx: {
              borderRadius: "4px 4px 0 0",
              background: "#F5F5F5",
              borderBottom: "1px solid rgba(9, 12, 16, 0.08)"
            },
            height: "100%",
            width: "100%",
            px: 1,
            py: 1,
            children: [
              /* @__PURE__ */ r(
                Lt,
                {
                  variant: "body2",
                  sx: { color: "rgba(9, 12, 16, 0.6)" },
                  children: "Magic Description"
                }
              ),
              /* @__PURE__ */ r(
                Lt,
                {
                  sx: {
                    "@keyframes blink": {
                      "from, to": {
                        color: "transparent"
                      },
                      "50%": {
                        color: "#CB0000"
                      }
                    },
                    fontStyle: "italic",
                    "&::after": {
                      content: '"|"',
                      fontWeight: "bold",
                      color: "#CB0000",
                      animation: "blink step-end 1.2s infinite"
                    },
                    ...e && {
                      color: "rgba(9, 12, 16, 0.6)"
                    }
                  },
                  children: i
                }
              )
            ]
          }
        )
      ]
    }
  );
};
var _ = /* @__PURE__ */ ((t) => (t.End = "end", t.Step = "step", t.Cover = "cover", t.Intro = "intro", t.Outro = "outro", t))(_ || {});
const ts = (t) => t === "cover" ? 0 : 1, es = (t, e) => (t + e).toString().padStart(2, "0"), rs = (t, e) => e + (t === "intro" ? 1 : 0), os = (t) => t.findIndex((e) => {
  var a;
  const o = e, i = ((a = o.recordingEvent) == null ? void 0 : a.name) === "introduction", n = o.kind === "step" && (!o.recordingEvent || o.recordingEvent.name === "recording");
  return i || n;
}), is = (t) => {
  var i;
  const e = t.filter((n) => {
    var l;
    const a = n;
    return a.kind === "step" && ((l = a.layers) == null ? void 0 : l.every((c) => c.type !== "video"));
  });
  if (!e.length)
    return "black";
  const o = e.flatMap((n) => n.layers ?? []).find((n) => n.type === "circleWithText");
  return ((i = o == null ? void 0 : o.text) == null ? void 0 : i.color) ?? "black";
}, ri = (t) => {
  if (t.title)
    return t.title;
  if (t.kind === "end" && !t.title)
    return "Thank you";
  const e = t.layers.find((o) => o.type === "text" && o.title);
  return (e == null ? void 0 : e.title) ?? "";
}, oi = (t) => /<\/?[a-z][\s\S]*>/i.test(t), ii = (t) => {
  const e = document.createElement("div");
  e.innerHTML = t;
  const o = [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "ul",
    "ol",
    "li",
    "a",
    "mark"
  ], i = {
    a: ["href", "target", "rel"],
    mark: ["style"]
  }, n = (a) => {
    var l;
    if (a.nodeType !== Node.TEXT_NODE && a.nodeType === Node.ELEMENT_NODE) {
      const c = a, d = c.tagName.toLowerCase();
      if (!o.includes(d)) {
        const h = String(c.textContent), v = document.createTextNode(h);
        (l = c.parentNode) == null || l.replaceChild(v, c);
        return;
      }
      const p = d in i ? i[d] : [], f = [];
      Array.from(c.attributes).forEach((h) => {
        p.includes(h.name) || f.push(h.name);
      }), f.forEach((h) => {
        c.removeAttribute(h);
      }), d === "a" && c.getAttribute("target") === "_blank" && c.setAttribute("rel", "noopener noreferrer"), Array.from(c.childNodes).forEach((h) => {
        n(h);
      });
    }
  };
  return n(e), e.innerHTML;
}, ni = ({ html: t, kind: e, fontFamily: o, shouldIgnoreCustomTags: i, styling: n }) => {
  const a = ii(t), c = `grey.${e === _.Cover ? 700 : 950}`, d = i ? {
    fontSize: `${n.fontSizeInPx} !important`,
    lineHeight: `${n.lineHeight} !important`,
    fontWeight: `${n.fontWeightInPx} !important`,
    fontFamily: `${o}, sans-serif !important`,
    margin: 0
  } : {};
  if (!oi(t)) {
    const p = a.replace(/<[^>]*>?/g, "");
    return /* @__PURE__ */ r(
      A,
      {
        variant: "text",
        color: c,
        fontWeight: n.fontWeight,
        size: n.fontSize,
        children: p
      }
    );
  }
  return /* @__PURE__ */ r(
    m,
    {
      id: "raw-html-component",
      sx: {
        "& *": d,
        "& a": {
          color: "rgb(21, 112, 239)"
        },
        "& p:empty": {
          display: "block",
          height: n.lineHeight
        },
        overflowWrap: "break-word"
      },
      children: /* @__PURE__ */ r(m, { dangerouslySetInnerHTML: { __html: t } })
    }
  );
}, ae = ({ note: t, fontFamily: e, shouldIgnoreCustomTags: o, styling: i, kind: n }) => /* @__PURE__ */ r(
  m,
  {
    maxWidth: "100%",
    position: "relative",
    id: "step-description",
    fontFamily: e,
    sx: {
      overflowWrap: "break-word"
    },
    pb: "6px",
    mt: s[i.marginTop],
    children: /* @__PURE__ */ r(
      ni,
      {
        html: t,
        fontFamily: e,
        styling: i,
        shouldIgnoreCustomTags: o,
        kind: n
      }
    )
  }
);
ae.displayName = "StepDescriptionView";
const ai = Y(ae), si = ({ hasVideoLayer: t, fontSize: e }) => t ? /* @__PURE__ */ g(
  m,
  {
    display: "flex",
    alignItems: "center",
    sx: {
      position: "absolute",
      top: 16,
      left: 16,
      background: "black",
      color: "white",
      padding: "4px 5px",
      borderRadius: "4px"
    },
    children: [
      /* @__PURE__ */ r(b, { icon: ze }),
      /* @__PURE__ */ r(m, { px: s.xs, children: /* @__PURE__ */ r(
        A,
        {
          variant: "text",
          fontWeight: "medium",
          color: "white",
          size: e,
          children: "Video content"
        }
      ) })
    ]
  }
) : null, se = ({
  imageUrl: t,
  title: e,
  stepLabel: o,
  isRtl: i,
  minHeight: n = 350,
  width: a = "100%",
  shouldShowScreenshotDialogOnClick: l
}) => {
  const [c, d] = N(!1), [p, f] = N(!1), [x, h] = N(""), v = mt(null), w = () => {
    d(!0), v.current && (v.current.style.display = "none");
  }, S = O(async () => {
    d(!0);
    try {
      const C = await (await fetch(t)).blob(), u = URL.createObjectURL(C);
      h(u);
    } catch (I) {
      console.error("Error loading image:", I);
    }
  }, [t]);
  return /* @__PURE__ */ g(Z, { children: [
    /* @__PURE__ */ r(
      Q,
      {
        isOpen: p,
        onClose: () => {
          f(!1);
        },
        useDefaultCloseButton: !1,
        size: "xl",
        children: /* @__PURE__ */ g(
          T,
          {
            overflow: "hidden",
            spacing: 0,
            id: "myDialog",
            children: [
              /* @__PURE__ */ g(
                m,
                {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: i ? "row-reverse" : "row",
                  px: 2,
                  py: 1,
                  borderBottom: "1px solid #c5c5c5",
                  children: [
                    /* @__PURE__ */ g(
                      m,
                      {
                        display: "flex",
                        alignItems: "center",
                        flexDirection: i ? "row-reverse" : "row",
                        children: [
                          /* @__PURE__ */ r(
                            m,
                            {
                              position: "relative",
                              width: "auto !important",
                              style: { marginRight: i ? 0 : "8px" },
                              children: /* @__PURE__ */ r("bdi", { children: o })
                            }
                          ),
                          /* @__PURE__ */ r(
                            m,
                            {
                              fontSize: 20,
                              fontWeight: 500,
                              children: /* @__PURE__ */ r("bdi", { children: e })
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ r(
                      ct,
                      {
                        variant: "text",
                        onClick: () => {
                          f(!1);
                        },
                        size: "large",
                        color: "secondary",
                        label: "Close",
                        children: /* @__PURE__ */ r(b, { icon: Ut })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ r(
                m,
                {
                  display: "flex",
                  justifyContent: "center",
                  children: /* @__PURE__ */ r(
                    "img",
                    {
                      src: x,
                      style: {
                        height: "auto",
                        overflow: "hidden",
                        width: "100%"
                      },
                      alt: "preview"
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ),
    !c && /* @__PURE__ */ r(
      m,
      {
        width: "100%",
        height: "100%",
        minHeight: n,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        children: /* @__PURE__ */ r(
          Vt,
          {
            variant: "rectangular",
            style: { height: 312, width: a, borderRadius: 12 }
          }
        )
      }
    ),
    /* @__PURE__ */ r(
      "img",
      {
        ref: v,
        src: t,
        width: a,
        draggable: !1,
        onLoad: () => {
          S();
        },
        onError: w,
        onClick: () => {
          l && f(!0);
        },
        style: {
          height: c ? "auto" : 0,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          borderRadius: 8,
          objectFit: "cover",
          cursor: l ? "pointer" : "default"
        },
        alt: "preview"
      }
    )
  ] });
};
se.displayName = "ImageWithLoad";
const li = se, ci = (t, e) => {
  if (!t)
    return t;
  try {
    const o = new URL(t);
    return Object.entries(e).forEach(([i, n]) => {
      o.searchParams.append(i, n);
    }), o.toString();
  } catch (o) {
    return console.error("Error appending query params", o), t;
  }
}, di = ({
  hasVideoLayer: t,
  shouldShowScreenshotDialogOnClick: e,
  isRtl: o,
  stepLabel: i,
  fontSize: n,
  screenshot: a = "",
  recordingEvent: l = void 0,
  title: c
}) => {
  const d = ot(
    () => ci(a, { time: Date.now().toString() }),
    [a]
  );
  return !a && (l != null && l.name) ? /* @__PURE__ */ r(
    Vt,
    {
      variant: "rectangular",
      height: "350px",
      width: "100%",
      sx: { borderRadius: "12px" }
    }
  ) : a ? /* @__PURE__ */ g(m, { position: "relative", children: [
    /* @__PURE__ */ r(
      li,
      {
        imageUrl: d,
        title: c,
        stepLabel: i,
        shouldShowScreenshotDialogOnClick: e,
        isRtl: o
      }
    ),
    /* @__PURE__ */ r(
      si,
      {
        hasVideoLayer: t,
        fontSize: n
      }
    )
  ] }) : null;
}, Pt = ({ mt: t, text: e, styling: o, onClick: i }) => /* @__PURE__ */ r(
  m,
  {
    mt: s[t],
    style: { cursor: "pointer" },
    onClick: i,
    children: /* @__PURE__ */ r(
      A,
      {
        variant: "text",
        fontWeight: o.fontWeight,
        size: o.fontSize,
        color: "primary.600",
        children: e
      }
    )
  }
), pi = ({ cta: t = void 0, onCtaClick: e, styling: o }) => {
  if ((t == null ? void 0 : t.ctaType) === "single" && t.action.isEnabled)
    return /* @__PURE__ */ r(
      Pt,
      {
        text: t.action.text,
        onClick: () => {
          e(t.action);
        },
        styling: o,
        mt: o.titleMarginTop
      }
    );
  if ((t == null ? void 0 : t.ctaType) === "multiple") {
    const i = t.actions.length > 1 ? o.spacing : o.titleMarginTop;
    return /* @__PURE__ */ g(m, { mt: o.titleMarginTop, children: [
      /* @__PURE__ */ r(
        A,
        {
          variant: "text",
          color: "primary.950",
          fontWeight: o.multipleActionsTitleFontWeight,
          size: o.multipleActionsTitleFontSize,
          children: t.title
        }
      ),
      t.actions.map((n, a) => /* @__PURE__ */ r(
        Pt,
        {
          text: n.text,
          onClick: () => {
            e(n);
          },
          styling: o,
          mt: i
        },
        a
      ))
    ] });
  }
  return null;
}, gi = ({ styling: t, title: e }) => /* @__PURE__ */ r(
  A,
  {
    fontWeight: t.fontWeight,
    size: t.fontSize,
    variant: t.variant,
    color: "grey.950",
    canWrap: !0,
    children: /* @__PURE__ */ r("bdi", { children: e })
  }
), mi = ({
  mt: t,
  children: e,
  stepLabel: o,
  onMouseOver: i = () => {
  },
  onMouseLeave: n = () => {
  }
}) => {
  const a = t ? s[t] : void 0;
  return /* @__PURE__ */ g(
    m,
    {
      mt: a,
      onMouseOver: i,
      onMouseLeave: n,
      sx: {
        // Ensure a block formatting context so text can wrap around the floated shape
        display: "block",
        overflow: "visible"
      },
      children: [
        o,
        e
      ]
    }
  );
}, fi = ({ stepNumber: t, kind: e, styling: o, stepNumberingColor: i }) => {
  switch (e) {
    case _.Intro:
      return "Intro";
    case _.Cover:
      return null;
    case _.Step:
      return /* @__PURE__ */ r(
        A,
        {
          size: o.fontSize,
          fontWeight: o.fontWeight,
          variant: o.variant,
          color: i,
          component: "span",
          children: t
        }
      );
    case _.End:
      return /* @__PURE__ */ r(
        b,
        {
          icon: We,
          style: { color: i }
        }
      );
    case _.Outro:
      return "Outro";
    default:
      return "";
  }
}, le = ({
  styling: t,
  isRtl: e,
  gap: o,
  stepNumber: i,
  kind: n,
  brandKitHighlightColor: a = "",
  stepNumberingColor: l = "black"
}) => {
  const c = fi({ stepNumber: i, isRtl: e, kind: n, styling: t, stepNumberingColor: l }), d = n === _.Step;
  return n === _.Cover ? null : /* @__PURE__ */ r(
    m,
    {
      sx: {
        background: a,
        marginLeft: e ? "5px" : 0,
        width: t.containerSize,
        height: `calc(${t.containerSize} - 1px)`,
        maxHeight: t.containerSize,
        color: l,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...d && {
          marginRight: e ? "0" : s[o],
          marginLeft: e ? s[o] : "0",
          float: e ? "right" : "left"
        }
      },
      children: c
    }
  );
};
le.displayName = "DocStepLabel";
const ui = Y(le), hi = ({ children: t, stepId: e }) => /* @__PURE__ */ r(
  m,
  {
    position: "relative",
    id: e,
    children: t
  }
), xi = (t) => t.docScreenshot ?? t.previewScreenshot ?? t.drawnScreenshot, ce = ({
  stepProgress: t,
  disableActions: e,
  font: o,
  isFirstStep: i,
  isStepsGenerating: n,
  originalIndex: a,
  stepNumberingColor: l,
  shouldIgnoreCustomTags: c,
  step: d,
  styling: p,
  stepNumber: f,
  shouldShowMagicAnimation: x = !1,
  brandKitHighlightColor: h,
  steps: v,
  onCtaClick: w = () => {
  },
  isRtl: S,
  jumpToStepInVideo: k = () => {
  }
}) => {
  const { kind: L, id: I, cta: C, description: u = "", layers: F } = d, D = L === _.Step, P = F.some((E) => E.type === "video"), X = ot(
    () => /* @__PURE__ */ r(
      ui,
      {
        isRtl: S,
        stepNumber: f,
        styling: p.numberIcon,
        kind: L,
        gap: p.numberIcon.marginRight,
        brandKitHighlightColor: h,
        stepNumberingColor: l
      }
    ),
    [S, f, p, L, h, l]
  ), tt = () => {
    const E = v.reduce((H, j, dt) => {
      if (dt >= a)
        return H;
      const { duration: xt, transition: it } = j;
      return H + xt + ((it == null ? void 0 : it.duration) ?? 0);
    }, 0);
    k(E);
  }, K = L === _.Cover || i ? void 0 : p.title.marginTop;
  return !x && !u && !D ? null : /* @__PURE__ */ g(hi, { stepId: I, children: [
    /* @__PURE__ */ r(
      mi,
      {
        onMouseOver: () => {
        },
        onMouseLeave: () => {
        },
        mt: K,
        stepLabel: X,
        children: !!D && /* @__PURE__ */ r(
          gi,
          {
            styling: p.title,
            title: ri(d)
          }
        )
      }
    ),
    !!x && /* @__PURE__ */ r(
      ei,
      {
        description: u,
        isStepsGenerating: n,
        progress: t
      }
    ),
    !!u && !x && /* @__PURE__ */ r(
      m,
      {
        sx: {
          borderBottom: L === _.Cover ? "0.5px solid rgba(9, 12, 16, 0.08)" : "none"
        },
        children: /* @__PURE__ */ r(
          ai,
          {
            note: u,
            kind: L,
            fontFamily: `${o.fontFamily}, sans-serif`,
            styling: p.description,
            shouldIgnoreCustomTags: c
          }
        )
      }
    ),
    !e && /* @__PURE__ */ r(
      pi,
      {
        cta: C,
        onCtaClick: w,
        styling: p.action
      }
    ),
    !!D && /* @__PURE__ */ r(m, { mt: s[p.screenshot.marginTop], children: /* @__PURE__ */ r(
      di,
      {
        title: d.title,
        screenshot: xi(d),
        shouldShowScreenshotDialogOnClick: !e,
        recordingEvent: d.recordingEvent,
        hasVideoLayer: P,
        stepLabel: X,
        isRtl: S,
        fontSize: p.screenshot.fontSize
      }
    ) }),
    !!(P && !e) && /* @__PURE__ */ r(
      m,
      {
        onClick: tt,
        sx: { cursor: "pointer" },
        mt: s[p.action.marginTop],
        children: /* @__PURE__ */ r(
          A,
          {
            variant: "text",
            size: p.action.fontSize,
            fontWeight: p.action.fontWeight,
            color: "primary.600",
            children: "Jump to this step in video"
          }
        )
      }
    )
  ] });
};
ce.displayName = "DocStep";
const ns = Y(ce), de = ({
  children: t,
  placeholder: e,
  inViewCallback: o = void 0,
  threshold: i = 0.5,
  delay: n = 500,
  shouldTriggerOnce: a = !0
}) => {
  const { ref: l, inView: c } = Er({
    threshold: i,
    delay: n,
    triggerOnce: !0
  });
  return c ? /* @__PURE__ */ r(
    Br,
    {
      onChange: (d) => {
        d && (o == null || o());
      },
      delay: n,
      triggerOnce: a,
      threshold: i,
      children: t
    }
  ) : /* @__PURE__ */ r(m, { ref: l, children: e });
};
de.displayName = "VisibilitySensor";
const as = Y(de), pe = st(({ children: t, isRtl: e }, o) => /* @__PURE__ */ r(
  m,
  {
    ref: o,
    pt: 1,
    m: "0 auto",
    width: "100%",
    sx: {
      direction: e ? "rtl" : "ltr"
    },
    children: t
  }
));
pe.displayName = "DocumentStepsContainer";
const ss = pe, vi = (t, e, o) => {
  const i = t[e];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((n, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      a.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== o ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, ge = ({ locale: t, size: e }) => {
  const [o, i] = N(!1), [n, a] = N(null), l = t.toUpperCase();
  return ft(() => {
    let c = !1;
    return i(!1), a(null), vi(/* @__PURE__ */ Object.assign({ "./flags/AD.svg": () => import("./AD-CY5W0iaF.js"), "./flags/AE.svg": () => import("./AE-D7Z3hnf1.js"), "./flags/AF.svg": () => import("./AF-C8w0cvSS.js"), "./flags/AG.svg": () => import("./AG-Bp6ps2CU.js"), "./flags/AI.svg": () => import("./AI-zoa-oQ0_.js"), "./flags/AL.svg": () => import("./AL-tP8n7aoj.js"), "./flags/AM.svg": () => import("./AM-kA-pU76E.js"), "./flags/AO.svg": () => import("./AO-DN5aIBzx.js"), "./flags/AR.svg": () => import("./AR-DyeUFyTK.js"), "./flags/AS.svg": () => import("./AS-CasX5N5-.js"), "./flags/AT.svg": () => import("./AT-BrMX4enl.js"), "./flags/AU.svg": () => import("./AU-oy6VJLhK.js"), "./flags/AW.svg": () => import("./AW-CB33vh_5.js"), "./flags/AX.svg": () => import("./AX-Bej5HCfW.js"), "./flags/AZ.svg": () => import("./AZ-CL1y6Sze.js"), "./flags/BA.svg": () => import("./BA-BEWdu2Vf.js"), "./flags/BB.svg": () => import("./BB-DJ3jb_pI.js"), "./flags/BD.svg": () => import("./BD-BBLH8hKg.js"), "./flags/BE.svg": () => import("./BE-BZwabkB3.js"), "./flags/BF.svg": () => import("./BF-Fj94jK1o.js"), "./flags/BG.svg": () => import("./BG-woeoPTG7.js"), "./flags/BH.svg": () => import("./BH-CcdMNzGr.js"), "./flags/BI.svg": () => import("./BI-J3qkeG07.js"), "./flags/BJ.svg": () => import("./BJ-hLRPQOat.js"), "./flags/BL.svg": () => import("./BL-ADUiC7Wp.js"), "./flags/BM.svg": () => import("./BM-CjKHcuUj.js"), "./flags/BN.svg": () => import("./BN-CJ3k-7Sa.js"), "./flags/BO.svg": () => import("./BO-CxBQFUpa.js"), "./flags/BQ.svg": () => import("./BQ-BeyC_jea.js"), "./flags/BR.svg": () => import("./BR-Cb_dEM6d.js"), "./flags/BS.svg": () => import("./BS-D3c2T-0n.js"), "./flags/BT.svg": () => import("./BT-J_nWlEXv.js"), "./flags/BW.svg": () => import("./BW-DVhMqlPm.js"), "./flags/BY.svg": () => import("./BY-BBCoNruv.js"), "./flags/BZ.svg": () => import("./BZ-BZQXo_5n.js"), "./flags/CA.svg": () => import("./CA-GmtJ-k-t.js"), "./flags/CC.svg": () => import("./CC-D6g5N16u.js"), "./flags/CD.svg": () => import("./CD-C6vxL0lk.js"), "./flags/CF.svg": () => import("./CF-CZZfC0NG.js"), "./flags/CH.svg": () => import("./CH-D9jsr60e.js"), "./flags/CK.svg": () => import("./CK-CRyf0A99.js"), "./flags/CL.svg": () => import("./CL-CswVulRX.js"), "./flags/CM.svg": () => import("./CM-CVll2Tlo.js"), "./flags/CN.svg": () => import("./CN-CSC1JLBw.js"), "./flags/CO.svg": () => import("./CO-C6RvH7ZH.js"), "./flags/CR.svg": () => import("./CR-Sx4BCnsi.js"), "./flags/CU.svg": () => import("./CU-BFG5RjhM.js"), "./flags/CW.svg": () => import("./CW-CPY1iMtz.js"), "./flags/CX.svg": () => import("./CX-DiIQkoPR.js"), "./flags/CY.svg": () => import("./CY-C2iI6psx.js"), "./flags/CZ.svg": () => import("./CZ-CXrvLOBE.js"), "./flags/DE.svg": () => import("./DE-ukPwf0xF.js"), "./flags/DJ.svg": () => import("./DJ-CVkdwsu0.js"), "./flags/DK.svg": () => import("./DK-BqOSJLGE.js"), "./flags/DM.svg": () => import("./DM-26JIpB5I.js"), "./flags/DO.svg": () => import("./DO-BqzuVof9.js"), "./flags/DS.svg": () => import("./DS-C01rD2UP.js"), "./flags/DZ.svg": () => import("./DZ-BZhm-jFI.js"), "./flags/EC.svg": () => import("./EC-DZ-46JuI.js"), "./flags/EE.svg": () => import("./EE-BM_Iu7Sj.js"), "./flags/EG.svg": () => import("./EG-DKkbv6yu.js"), "./flags/EH.svg": () => import("./EH-C4-iVZD0.js"), "./flags/ER.svg": () => import("./ER-DFnTjGol.js"), "./flags/ES.svg": () => import("./ES-BIeZfg_B.js"), "./flags/ET.svg": () => import("./ET-Dz4gyilh.js"), "./flags/FI.svg": () => import("./FI-dAQNXEEv.js"), "./flags/FJ.svg": () => import("./FJ-DR4GNI4N.js"), "./flags/FK.svg": () => import("./FK-D4LUaZba.js"), "./flags/FM.svg": () => import("./FM-DcrliKrD.js"), "./flags/FO.svg": () => import("./FO-CyHgl-Oe.js"), "./flags/FR.svg": () => import("./FR-DX57_ZrM.js"), "./flags/GA.svg": () => import("./GA-DwKyuADJ.js"), "./flags/GB.svg": () => import("./GB-CC0ANtOU.js"), "./flags/GD.svg": () => import("./GD-BUZUJ1_U.js"), "./flags/GE.svg": () => import("./GE-BAmMPwQb.js"), "./flags/GG.svg": () => import("./GG-tXp7ZhZO.js"), "./flags/GH.svg": () => import("./GH-D9tmvt7G.js"), "./flags/GI.svg": () => import("./GI-J96jD0vs.js"), "./flags/GL.svg": () => import("./GL-DzjX-lc1.js"), "./flags/GM.svg": () => import("./GM-BTDWRLue.js"), "./flags/GN.svg": () => import("./GN-PsqQJQYI.js"), "./flags/GQ.svg": () => import("./GQ-DkGe_Su8.js"), "./flags/GR.svg": () => import("./GR-CKOve8TC.js"), "./flags/GT.svg": () => import("./GT-Cw5zeUdH.js"), "./flags/GU.svg": () => import("./GU-BTzNBUQb.js"), "./flags/GW.svg": () => import("./GW-BVdqXR35.js"), "./flags/GY.svg": () => import("./GY-Cq-NzO7u.js"), "./flags/HK.svg": () => import("./HK-BAOWrAt4.js"), "./flags/HN.svg": () => import("./HN-BZ_iVp7O.js"), "./flags/HR.svg": () => import("./HR-Bc7vHYZe.js"), "./flags/HT.svg": () => import("./HT-DZb9RhqQ.js"), "./flags/HU.svg": () => import("./HU-bOlfs-ow.js"), "./flags/ID.svg": () => import("./ID-ioL8jgPU.js"), "./flags/IE.svg": () => import("./IE-C0ezEV-f.js"), "./flags/IL.svg": () => import("./IL-BnxRBwXF.js"), "./flags/IM.svg": () => import("./IM-ClPpmiYy.js"), "./flags/IN.svg": () => import("./IN-DuanWEkF.js"), "./flags/IO.svg": () => import("./IO-D5hPhzBb.js"), "./flags/IQ.svg": () => import("./IQ-_DQl3Dyc.js"), "./flags/IR.svg": () => import("./IR-D9R4VnWf.js"), "./flags/IS.svg": () => import("./IS-CzmPpRAM.js"), "./flags/IT.svg": () => import("./IT-BCqQ_BRB.js"), "./flags/JE.svg": () => import("./JE-CWtDcSKo.js"), "./flags/JM.svg": () => import("./JM-SGcKvU69.js"), "./flags/JO.svg": () => import("./JO-CPB8XvWN.js"), "./flags/JP.svg": () => import("./JP-RX08yDBV.js"), "./flags/KE.svg": () => import("./KE-B8aNFpQi.js"), "./flags/KG.svg": () => import("./KG-BdpmQDEk.js"), "./flags/KH.svg": () => import("./KH-BDNtJV6Y.js"), "./flags/KI.svg": () => import("./KI-DFIK6-k2.js"), "./flags/KM.svg": () => import("./KM-CiEX62B9.js"), "./flags/KN.svg": () => import("./KN-DYba9YdF.js"), "./flags/KP.svg": () => import("./KP-zMeVtPi1.js"), "./flags/KR.svg": () => import("./KR-CX4JPNnr.js"), "./flags/KW.svg": () => import("./KW-Bmt-xpip.js"), "./flags/KY.svg": () => import("./KY-BwYtObEt.js"), "./flags/KZ.svg": () => import("./KZ-D7Nc5xPd.js"), "./flags/LA.svg": () => import("./LA-C3O8YnUv.js"), "./flags/LB.svg": () => import("./LB-FYQ97jZP.js"), "./flags/LC.svg": () => import("./LC-Bpxw3Kat.js"), "./flags/LI.svg": () => import("./LI-HtnHPBW5.js"), "./flags/LK.svg": () => import("./LK-J0yUiOve.js"), "./flags/LR.svg": () => import("./LR-DLEZAwmY.js"), "./flags/LS.svg": () => import("./LS-CnBUwygN.js"), "./flags/LT.svg": () => import("./LT-Z61bmMAY.js"), "./flags/LU.svg": () => import("./LU-Dh4lbSsA.js"), "./flags/LV.svg": () => import("./LV-Ck63FtqF.js"), "./flags/LY.svg": () => import("./LY-CY2L3YXl.js"), "./flags/MA.svg": () => import("./MA-BJp7GKcp.js"), "./flags/MC.svg": () => import("./MC-DmEOE0xa.js"), "./flags/MD.svg": () => import("./MD-BmAiaocc.js"), "./flags/ME.svg": () => import("./ME-uTZE7QQV.js"), "./flags/MG.svg": () => import("./MG-DD7FW651.js"), "./flags/MH.svg": () => import("./MH-DR1-OU3h.js"), "./flags/MK.svg": () => import("./MK-C81d-Kmg.js"), "./flags/ML.svg": () => import("./ML-C6JvL3a_.js"), "./flags/MM.svg": () => import("./MM-B4237Hws.js"), "./flags/MN.svg": () => import("./MN-DQlDfPqX.js"), "./flags/MO.svg": () => import("./MO-DPh-ueLM.js"), "./flags/MP.svg": () => import("./MP-DwQ1W-CZ.js"), "./flags/MQ.svg": () => import("./MQ-BMZYO7Ot.js"), "./flags/MR.svg": () => import("./MR-Cgr75kph.js"), "./flags/MS.svg": () => import("./MS-DrjD4BA5.js"), "./flags/MT.svg": () => import("./MT-Dx9GlE7t.js"), "./flags/MU.svg": () => import("./MU-akqFfpEI.js"), "./flags/MV.svg": () => import("./MV-IIgedaRW.js"), "./flags/MW.svg": () => import("./MW-DTAHMEWJ.js"), "./flags/MX.svg": () => import("./MX-B41Mqfc3.js"), "./flags/MY.svg": () => import("./MY-BPO9ufIh.js"), "./flags/MZ.svg": () => import("./MZ-Cm3bB2HY.js"), "./flags/NA.svg": () => import("./NA-BFzLJpAy.js"), "./flags/NE.svg": () => import("./NE-Rf19agF_.js"), "./flags/NF.svg": () => import("./NF-CA1mbgkS.js"), "./flags/NG.svg": () => import("./NG-BKxRJaLX.js"), "./flags/NI.svg": () => import("./NI-BYWBr-MT.js"), "./flags/NL.svg": () => import("./NL-67ajaXW4.js"), "./flags/NO.svg": () => import("./NO-BbsYC-yA.js"), "./flags/NP.svg": () => import("./NP-CdPK3HIW.js"), "./flags/NR.svg": () => import("./NR-CAql5ZFZ.js"), "./flags/NU.svg": () => import("./NU-Cn0BfOOA.js"), "./flags/NZ.svg": () => import("./NZ-BQ2x2VAP.js"), "./flags/OM.svg": () => import("./OM-DLMQwMHJ.js"), "./flags/PA.svg": () => import("./PA-CXmf_saE.js"), "./flags/PE.svg": () => import("./PE-Blkiobfz.js"), "./flags/PF.svg": () => import("./PF-DD9uh3Kp.js"), "./flags/PG.svg": () => import("./PG-CbRTWRBn.js"), "./flags/PH.svg": () => import("./PH-B1RGIo6w.js"), "./flags/PK.svg": () => import("./PK-CiBfSibk.js"), "./flags/PL.svg": () => import("./PL-CzmqW-Hb.js"), "./flags/PN.svg": () => import("./PN-Cos3lQta.js"), "./flags/PR.svg": () => import("./PR-DYz-r81s.js"), "./flags/PS.svg": () => import("./PS-CeKO32Gi.js"), "./flags/PT.svg": () => import("./PT-BRg1Chh0.js"), "./flags/PW.svg": () => import("./PW-7yHcTV-k.js"), "./flags/PY.svg": () => import("./PY-BGUwqmFG.js"), "./flags/QA.svg": () => import("./QA-B3pdMQ5n.js"), "./flags/RO.svg": () => import("./RO-DUjGuNO8.js"), "./flags/RS.svg": () => import("./RS-C3o2UXeM.js"), "./flags/RU.svg": () => import("./RU-DjxruBqe.js"), "./flags/RW.svg": () => import("./RW-CsQo9U6S.js"), "./flags/SA.svg": () => import("./SA-DDQrmShA.js"), "./flags/SB.svg": () => import("./SB-B54hr2fI.js"), "./flags/SC.svg": () => import("./SC-ZcBy8Dl8.js"), "./flags/SE.svg": () => import("./SE-BhSGh0Q3.js"), "./flags/SG.svg": () => import("./SG-CjyGlBiC.js"), "./flags/SI.svg": () => import("./SI-CWh9hyfv.js"), "./flags/SK.svg": () => import("./SK-D11vdIwe.js"), "./flags/SL.svg": () => import("./SL-miGSAf-G.js"), "./flags/SM.svg": () => import("./SM-BqV5U5DY.js"), "./flags/SN.svg": () => import("./SN-Qr9CQHo4.js"), "./flags/SO.svg": () => import("./SO-CWSDIFAW.js"), "./flags/SR.svg": () => import("./SR-ebW6HnK4.js"), "./flags/SS.svg": () => import("./SS-B31Jyk2P.js"), "./flags/ST.svg": () => import("./ST-tkLGrnpo.js"), "./flags/SV.svg": () => import("./SV-Dllvtwpg.js"), "./flags/SX.svg": () => import("./SX-BelZeRfE.js"), "./flags/SY.svg": () => import("./SY-C1rhm6c5.js"), "./flags/SZ.svg": () => import("./SZ-BLt4e0YD.js"), "./flags/TC.svg": () => import("./TC-CPGk9wRB.js"), "./flags/TD.svg": () => import("./TD-B9ecZxYz.js"), "./flags/TG.svg": () => import("./TG-B2FjH85t.js"), "./flags/TH.svg": () => import("./TH-C5XqODiT.js"), "./flags/TJ.svg": () => import("./TJ-BLzo8tT-.js"), "./flags/TK.svg": () => import("./TK-Bh-XhqyC.js"), "./flags/TL.svg": () => import("./TL-CNCSoc7n.js"), "./flags/TM.svg": () => import("./TM-Cu0GZ9Ry.js"), "./flags/TN.svg": () => import("./TN-SuKbQsk6.js"), "./flags/TO.svg": () => import("./TO-foyXVV05.js"), "./flags/TR.svg": () => import("./TR-Dhe0o-Ji.js"), "./flags/TT.svg": () => import("./TT-CXQo8StO.js"), "./flags/TV.svg": () => import("./TV-Baqo_yKo.js"), "./flags/TW.svg": () => import("./TW-GDJfuE0B.js"), "./flags/TZ.svg": () => import("./TZ-GiT1nlpL.js"), "./flags/UA.svg": () => import("./UA-BvnOexF9.js"), "./flags/UG.svg": () => import("./UG-CbD-Z1hh.js"), "./flags/US.svg": () => import("./US-CbQKnu7W.js"), "./flags/UY.svg": () => import("./UY-FTS-aSXP.js"), "./flags/UZ.svg": () => import("./UZ-T8a2YUha.js"), "./flags/VC.svg": () => import("./VC-Cygsgk_M.js"), "./flags/VE.svg": () => import("./VE-HliJksYX.js"), "./flags/VG.svg": () => import("./VG-Cj6nNNPi.js"), "./flags/VI.svg": () => import("./VI-C8dWSPtR.js"), "./flags/VN.svg": () => import("./VN-VTUeX8Ce.js"), "./flags/VU.svg": () => import("./VU-CrpSGC4L.js"), "./flags/WS.svg": () => import("./WS-DxNvoIAP.js"), "./flags/YE.svg": () => import("./YE-DTXsS8No.js"), "./flags/ZA.svg": () => import("./ZA-BQN9h7al.js"), "./flags/ZH.svg": () => import("./ZH-CSC1JLBw.js"), "./flags/ZM.svg": () => import("./ZM-ZeMJrer6.js"), "./flags/ZW.svg": () => import("./ZW-BI1IU_bO.js") }), `./flags/${l}.svg`, 3).then((d) => {
      c || a(d.default);
    }).catch(() => {
      c || i(!0);
    }), () => {
      c = !0;
    };
  }, [l]), o ? /* @__PURE__ */ r(m, { width: e }) : n ? /* @__PURE__ */ r(
    "img",
    {
      src: n,
      alt: t,
      width: e,
      height: e,
      onError: () => {
        i(!0);
      }
    }
  ) : /* @__PURE__ */ r(m, { width: e });
};
ge.displayName = "FlagIconComponent";
const ls = Y(ge), yi = B(Le)(({ theme: t, valueLabelDisplay: e }) => ({
  width: "100%",
  height: 8,
  "& .MuiSlider-thumb": {
    backgroundColor: "#fff",
    border: `2px solid ${t.palette.primary.main}`,
    width: 24,
    height: 24,
    "&:hover, &.Mui-active": {
      boxShadow: "none"
    }
  },
  "& .MuiSlider-track": {
    backgroundColor: t.palette.primary.main,
    height: 8
  },
  "& .MuiSlider-rail": {
    backgroundColor: t.palette.grey[300],
    height: 8
  },
  ...e === "on" && {
    "& .MuiSlider-thumb .MuiSlider-valueLabelOpen": {
      transform: "translateY(100%) scale(1)",
      bottom: -2,
      backgroundColor: "unset",
      color: t.palette.text.primary,
      "&::before": {
        display: "none"
      }
    }
  }
})), cs = ({
  value: t,
  onChange: e,
  title: o,
  titleSize: i = "md",
  min: n = 0,
  max: a = 100,
  step: l = 1,
  valueLabelFormat: c,
  valueLabelDisplay: d = "off",
  size: p = "medium",
  disabled: f = !1,
  sx: x
}) => {
  const h = O(
    (v, w) => {
      const S = Array.isArray(w) ? w[0] : w;
      e(S);
    },
    [e]
  );
  return /* @__PURE__ */ g(m, { sx: x, children: [
    !!o && /* @__PURE__ */ r(
      A,
      {
        variant: "text",
        size: i,
        fontWeight: "medium",
        color: "grey.700",
        children: o
      }
    ),
    /* @__PURE__ */ r(m, { sx: { marginTop: o ? i === "sm" ? s.xs : s.sm : 0 }, children: /* @__PURE__ */ r(
      yi,
      {
        value: t,
        onChange: h,
        min: n,
        max: a,
        step: l,
        size: p,
        disabled: f,
        valueLabelDisplay: d,
        valueLabelFormat: c,
        "aria-label": o ?? "Slider"
      }
    ) })
  ] });
};
export {
  as as $,
  lo as A,
  Kr as B,
  Jt as C,
  Ia as D,
  Na as E,
  Io as F,
  Ba as G,
  za as H,
  b as I,
  Wa as J,
  Ma as K,
  Qr as L,
  Q as M,
  Ta as N,
  $a as O,
  ie as P,
  Bo as Q,
  po as R,
  cs as S,
  fo as T,
  ja as U,
  Za as V,
  $o as W,
  Xa as X,
  Po as Y,
  Oa as Z,
  ko as _,
  no as a,
  os as a0,
  is as a1,
  ss as a2,
  ts as a3,
  es as a4,
  rs as a5,
  hi as a6,
  ns as a7,
  _ as a8,
  qa as a9,
  Uo as aa,
  ne as ab,
  Ya as ac,
  Tt as ad,
  Ka as ae,
  jo as af,
  Zo as ag,
  Ja as ah,
  Da as ai,
  Ct as aj,
  pt as ak,
  Vr as al,
  Ur as am,
  ya as an,
  wa as ao,
  ba as ap,
  Ca as aq,
  Sa as ar,
  Ha as as,
  Fa as b,
  qr as c,
  ct as d,
  ro as e,
  io as f,
  La as g,
  ee as h,
  vo as i,
  Qa as j,
  Yt as k,
  Qt as l,
  ka as m,
  Zr as n,
  Xr as o,
  Bt as p,
  _a as q,
  Va as r,
  Ga as s,
  Ua as t,
  Vo as u,
  ls as v,
  Aa as w,
  Ea as x,
  Ra as y,
  Pa as z
};
